(function(window, document) {
  "use strict";
  if (!document.body || !document.body.classList.contains("template-product")) {
    return;
  }
  var fitmentEngine = window.AuxitoFitmentEngine || null;
  var vehicleUtils = window.AuxitoVehicleUtils || null;
  if (!fitmentEngine || typeof fitmentEngine.fetchWithRetry !== "function" || typeof fitmentEngine.mapWithConcurrencyLimit !== "function" || typeof fitmentEngine.fetchDynamicFitmentYearData !== "function" || typeof fitmentEngine.buildDynamicSidebarGroups !== "function" || typeof fitmentEngine.flattenSidebarGroups !== "function" || typeof fitmentEngine.collectHandlesFromSourceUrls !== "function" || typeof fitmentEngine.getSourceUrlsForSelection !== "function" || typeof fitmentEngine.resolveEffectiveFilters !== "function" || typeof fitmentEngine.createEmptyFilters !== "function" || typeof fitmentEngine.readArtifactsConfig !== "function" || !vehicleUtils || typeof vehicleUtils.getCurrentVehicle !== "function" || typeof vehicleUtils.buildVehicleDisplay !== "function") {
    return;
  }
  var fetchWithRetry = fitmentEngine.fetchWithRetry;
  var dedupe = fitmentEngine.dedupeStrings;
  var mapWithConcurrencyLimit = fitmentEngine.mapWithConcurrencyLimit;
  var fetchDynamicFitmentYearData = fitmentEngine.fetchDynamicFitmentYearData;
  var buildDynamicSidebarGroups = fitmentEngine.buildDynamicSidebarGroups;
  var flattenSidebarGroups = fitmentEngine.flattenSidebarGroups;
  var collectHandlesFromSourceUrls = fitmentEngine.collectHandlesFromSourceUrls;
  var getSourceUrlsForSelection = fitmentEngine.getSourceUrlsForSelection;
  var resolveEffectiveFilters = fitmentEngine.resolveEffectiveFilters;
  var createEmptyFilters = fitmentEngine.createEmptyFilters;
  var readArtifactsConfig = fitmentEngine.readArtifactsConfig;
  var normalizeArtifactsBaseUrl = fitmentEngine.normalizeArtifactsBaseUrl;
  var resolveUrlAgainstBase = fitmentEngine.resolveUrlAgainstBase;
  var fetchVehicleLibraryManifest = typeof fitmentEngine.fetchVehicleLibraryManifest === "function" ? fitmentEngine.fetchVehicleLibraryManifest : function() { return Promise.resolve(null); };
  var getManifestArtifactUrl = typeof fitmentEngine.getManifestArtifactUrl === "function" ? fitmentEngine.getManifestArtifactUrl : function() { return ""; };
  var readCurrentVehicle = vehicleUtils.getCurrentVehicle;
  var buildVehicleDisplay = function(vehicle) {
    return vehicleUtils.buildVehicleDisplay(vehicle, "");
  };
  var CONTEXT_MAX_AGE_MS = 2 * 60 * 60 * 1e3;
  var FITMENT_VALIDATION_MAX_AGE_MS = CONTEXT_MAX_AGE_MS;
  // v5：包 D plug 窄化上线后，v4 及之前的缓存结论未经过插头级判定，必须废弃
  // v6：三状态（ALL / CONDITIONAL / UNKNOWN）上线，旧缓存里的 fits 可能是未选配置时的误判
  // v8：带 ledPending / configChosen / configQualifier（10-26 LED 提示），旧缓存缺这些字段；v7：缓存记下商品在车型数据里命中的来源链接（productSources），带 fit_location 的灯位判断要用；Not sure 走 Check Fitment
  var FITMENT_VALIDATION_STORAGE_KEY_PREFIX = "auxito:product-fitment-validation:v8";
  var FITMENT_VALIDATION_LEGACY_STORAGE_KEY_PREFIXES = [ "auxito:product-fitment-validation:v1::", "auxito:product-fitment-validation:v2::", "auxito:product-fitment-validation:v3::", "auxito:product-fitment-validation:v4::", "auxito:product-fitment-validation:v5::", "auxito:product-fitment-validation:v6::", "auxito:product-fitment-validation:v7::" ];
  var FITMENT_VALIDATION_LEGACY_CLEANUP_KEY = "auxito:product-fitment-validation:legacy-cleanup:v8";
  var DEFAULT_SKELETON_CARD_COUNT = 5;
  var MAX_PRODUCTS_TOTAL = 10;
  var DYNAMIC_PER_LOCATION_LIMIT = 1;
  var FITMENT_PENDING_UI_DELAY_MS = 300;
  var MAX_COLLECTION_PRODUCTS_TO_SCAN = 18;
  var MAX_COLLECTION_VIEW_PAGES = 40;
  var MAX_SOURCE_CONCURRENCY = 4;
  var MOBILE_VIEWPORT_MAX_WIDTH = 768;
  var COLLECTION_FITMENT_HANDLES_VIEW = "fitment-handles";
  var SOURCE_HANDLE_CACHE_MAX_AGE_MS = 5 * 60 * 1e3;
  var FITMENT_SOURCE_HANDLE_STORAGE_KEY_PREFIX = "auxito:product-fitment-source-handles:v1";
  var PDP_FITMENT_OVERRIDE_QUERY_PARAM = "auxito_pdp_fitment_version";
  var PDP_FITMENT_OVERRIDE_STORAGE_KEY = "auxito:product-fitment-compact-override:v1";
  var PDP_FITMENT_SOURCE_QUERY_PARAM = "auxito_pdp_fitment_source";
  var PDP_FITMENT_SOURCE_STORAGE_KEY = "auxito:product-fitment-compact-source:v1";
  var PDP_FITMENT_SOURCE_CDN = "cdn";
  var PDP_FITMENT_SOURCE_THEME = "theme";
  var PDP_FITMENT_SIMULATION_CONFIG_SCRIPT_ID = "auxito-pdp-fitment-simulation-config";
  var PDP_FITMENT_SIMULATION_DATA_SCRIPT_ID = "auxito-pdp-fitment-simulation-data";
  var PDP_FITMENT_CURRENT_PRODUCT_SOURCES_SCRIPT_ID = "auxito-pdp-fitment-current-product-sources";
  var PDP_FITMENT_VERSION_PATTERN = /^\d{6,}$/;
  var FITMENT_EXEMPT_PRODUCT_TYPE_KEYS = [ "jump starter", "jump starter tire inflator", "tire inflator", "off road light", "off road lights", "off road lighting", "car vacuum", "vacuum cleaner" ];
  var FITMENT_EXEMPT_COLLECTION_TOKENS = [ "universal", "universal parts", "off road light", "off road lights", "off road lighting", "led off road lights", "x plore", "jump starter", "tire inflator", "car vacuum", "vacuum cleaner" ];
  var APP_LABEL_MAP = {
    "off-road-lights": "Off Road Lights",
    "jump-starter": "Jump Starter",
    "tire-inflator": "Tire Inflator"
  };
  var FITS_ICON = '<svg aria-hidden="true" focusable="false" viewBox="0 0 32 32"><path fill="currentColor" d="M27.867 12.667h-1.733c-.667-.933-.667-.933-1.467-2.267-1.2-2-3.2-2.4-3.2-2.4l-5.333-.133-5.467.133s-2 .533-3.333 2.533c-.933 1.333-.667.8-1.467 2.133H4.133a.933.933 0 0 0-.933.933v.133c0 .533.4.933.933.933h1.067l-.533 1.6s-.267.533-.267 1.867v5.867c0 .667.533 1.333 1.333 1.333h2.133c.667 0 1.333-.533 1.333-1.333v-.8h13.867v.8c0 .667.533 1.333 1.333 1.333h2.133c.667 0 1.333-.533 1.333-1.333v-6c0-1.333-.267-1.867-.267-1.867l-.667-1.467h1.067c.533 0 .933-.4.933-.933v-.133c-.133-.533-.533-.933-1.067-.933ZM9.067 19.467l-2.8-.133a1.26 1.26 0 0 1-.8-.8c-.133-.4-.133-1.067 0-1.467.267-.8 1.2-.4 1.733-.133.8.267 1.6.667 2.4.933.533.133.8.533.8 1.067-.133.667-.933.533-1.333.533ZM16 14.533c-4.133 0-8.667-.8-8.667-.8l1.333-2.667c.533-1.467 2.667-1.6 2.667-1.6L16 9.333h4.667s2 .133 2.533 1.6l1.333 2.667c.133.133-4.4.933-8.533.933Zm10.533 4c-.133.4-.4.667-.8.8l-2.8.133c-.533 0-1.2 0-1.333-.533s.267-.933.8-1.067c.8-.267 1.6-.667 2.4-.933.533-.133 1.467-.533 1.733.133.133.4.133 1.067 0 1.467Z"></path></svg>';
  var FITMENT_MISMATCH_ICON = '<svg aria-hidden="true" focusable="false" viewBox="0 0 32 32"><path fill="currentColor" d="M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3Zm5.13 17.01-1.12 1.12L16 17.12l-4.01 4.01-1.12-1.12L14.88 16l-4.01-4.01 1.12-1.12L16 14.88l4.01-4.01 1.12 1.12L17.12 16Z"></path></svg>';
  var FITMENT_PENDING_SPINNER = '<span class="auxito-fits-info__spinner" aria-hidden="true"></span>';
  var sourceCache = new Map;
  var sourceHandleCache = new Map;
  var compactYearIndexCache = new Map;
  var compactYearGroupCache = new Map;
  var compactHandleSourcesCache = new Map;
  var compactSourceHandlesCache = new Map;
  var compactProductCache = new Map;
  var compactFixturePayloadCache = new Map;
  var compactCurrentProductSourceUrlsCache = null;
  var compactCurrentProductSourceUrlsCacheVersion = "";
  var dom = {
    section: document.querySelector("[data-product-fitment-section]"),
    title: document.querySelector("[data-product-fitment-title]"),
    controls: document.querySelector("[data-product-fitment-controls]"),
    prevButton: document.querySelector("[data-product-fitment-prev]"),
    nextButton: document.querySelector("[data-product-fitment-next]"),
    viewport: document.querySelector("[data-product-fitment-viewport]"),
    track: document.querySelector("[data-product-fitment-track]"),
    status: document.querySelector("[data-product-fitment-status]"),
    fitsTargets: Array.prototype.slice.call(document.querySelectorAll(".auxito-fits"))
  };
  var state = {
    product: null,
    context: null,
    recommendations: [],
    contextKey: "",
    activeLoadToken: 0,
    pendingFitmentUiTimer: 0,
    buttonResetTimer: 0,
    carouselFrame: 0,
    activeQuickshop: null
  };
  var quickshopRuntime = window.AuxitoQuickshopRuntime && typeof window.AuxitoQuickshopRuntime.createEnvironment === "function" ? window.AuxitoQuickshopRuntime.createEnvironment({
    fetchText: fetchText,
    enableBatchFetch: false,
    defaultQuickBuySettings: {
      cartRedirection: false,
      moneyFormat: window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : "${{amount}}"
    }
  }) : null;
  if (!dom.section || !dom.viewport || !dom.track || !dom.fitsTargets.length) {
    return;
  }
  state.product = readCurrentProduct();
  if (!state.product || !state.product.handle) {
    return;
  }
  cleanupLegacyValidationCache();
  bindEvents();
  initializeFitParamVehicle().then(function(wasHandled) {
    if (!wasHandled) {
      refreshFitment();
    }
  }).catch(function(error) {
    if (shouldLogDebugWarnings()) {
      console.warn("Failed to initialize fit vehicle parameter:", error);
    }
    refreshFitment();
  });
  function readCurrentProduct() {
    var node = document.querySelector('[data-section-type="static-product"][data-section-data]');
    var parsed;
    if (!node) {
      return null;
    }
    try {
      parsed = JSON.parse(node.textContent || "{}");
    } catch (error) {
      console.warn("Failed to parse static product section data:", error);
      return null;
    }
    if (!parsed || !parsed.product || !parsed.product.handle) {
      return null;
    }
    return {
      handle: str(parsed.product.handle),
      title: str(parsed.product.title),
      url: str(parsed.product.url || "/products/" + str(parsed.product.handle)),
      type: str(parsed.product.type),
      tags: Array.isArray(parsed.product.tags) ? parsed.product.tags.slice() : [],
      collections: normalizeProductCollections((parsed.product_fitment && parsed.product_fitment.collections) || (parsed.productFitment && parsed.productFitment.collections) || parsed.product.collections)
    };
  }
  function shouldLogDebugWarnings() {
    try {
      return !!(window.Shopify && window.Shopify.designMode) || new URLSearchParams(window.location.search || "").get("auxito_debug") === "1";
    } catch (error) {
      return false;
    }
  }
  function str(value) {
    return String(value == null ? "" : value).trim();
  }
  function lower(value) {
    return str(value).toLowerCase();
  }
  function normalizeFitmentToken(value) {
    return lower(value).replace(/&/g, " and ").replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim();
  }
  // 与 artifacts.server.js normalizePlugcode 语义对齐:空/"/"/null 一律视为无插头
  function normalizePlugcodeToken(value) {
    var raw = str(value);
    if (!raw || raw === "/" || lower(raw) === "null") {
      return "";
    }
    return raw.toUpperCase();
  }
  function collapseFitmentToken(value) {
    return normalizeFitmentToken(value).replace(/\s+/g, "");
  }
  function normalizeTags(tags) {
    if (!Array.isArray(tags)) {
      return [];
    }
    return tags.map(function(tag) {
      return lower(tag);
    }).filter(Boolean);
  }
  function productHasTag(product, tag) {
    return normalizeTags(product && product.tags).indexOf(lower(tag)) > -1;
  }
  function normalizeProductCollections(collections) {
    if (!Array.isArray(collections)) {
      return [];
    }
    return collections.map(function(collection) {
      if (typeof collection === "string") {
        return {
          handle: str(collection),
          title: str(collection),
          url: ""
        };
      }
      return {
        handle: str(collection && collection.handle),
        title: str(collection && collection.title),
        url: str(collection && collection.url)
      };
    }).filter(function(collection) {
      return collection.handle || collection.title || collection.url;
    });
  }
  function productCollectionHasToken(product, token) {
    var normalizedToken = normalizeFitmentToken(token);
    var collapsedToken = collapseFitmentToken(token);
    if (!normalizedToken) {
      return false;
    }
    return (Array.isArray(product && product.collections) ? product.collections : []).some(function(collection) {
      var collectionText = normalizeFitmentToken([ collection.handle, collection.title, collection.url ].join(" "));
      var collapsedCollectionText = collapseFitmentToken([ collection.handle, collection.title, collection.url ].join(" "));
      return !!collectionText && (collectionText.indexOf(normalizedToken) > -1 || (!!collapsedToken && collapsedCollectionText.indexOf(collapsedToken) > -1));
    });
  }
  function productHasExemptCollection(product) {
    return FITMENT_EXEMPT_COLLECTION_TOKENS.some(function(token) {
      return productCollectionHasToken(product, token);
    });
  }
  function isUniversalProduct(product) {
    return productHasTag(product, "Universal") || productHasTag(product, "Universal Parts") || productCollectionHasToken(product, "universal");
  }
  function isStaticFitmentExemptProduct(product) {
    var normalizedType = normalizeFitmentToken(product && product.type);
    return (!!normalizedType && FITMENT_EXEMPT_PRODUCT_TYPE_KEYS.indexOf(normalizedType) > -1) || productHasExemptCollection(product);
  }
  function parseVehicleSpecificProductFitment(product) {
    var title = str(product && product.title);
    var type = str(product && product.type);
    var descriptor = "";
    var match;
    if (!title) {
      return null;
    }
    if (type.indexOf(">") > -1) {
      descriptor = str(type.split(">").pop());
    }
    if (!descriptor && /^led for\b/i.test(type)) {
      descriptor = type;
    }
    descriptor = descriptor.replace(/^led for\b[:\s-]*/i, "").trim();
    if (!descriptor && /\bled bulbs?\b/i.test(title)) {
      descriptor = title.replace(/\bled bulbs?\b/i, "").trim();
    }
    if (!descriptor) {
      return null;
    }
    match = descriptor.match(/^(\d{4})(?:\s*-\s*(\d{4}))?\s+(.+)$/);
    if (!match) {
      return null;
    }
    return {
      startYear: Number(match[1]),
      endYear: Number(match[2] || match[1]),
      vehicleLabel: str(match[3]),
      categorySlug: "led-bulbs",
      queryCategory: "LED Bulbs"
    };
  }
  function matchesVehicleSpecificProductFitment(vehicle, target) {
    var vehicleYear = Number(str(vehicle && vehicle.year));
    var targetLabel;
    var currentVehicleLabel;
    if (!target || !vehicle || !vehicleYear || !target.startYear || !target.endYear) {
      return false;
    }
    if (vehicleYear < target.startYear || vehicleYear > target.endYear) {
      return false;
    }
    targetLabel = normalizeFitmentToken(target.vehicleLabel);
    currentVehicleLabel = normalizeFitmentToken([ str(vehicle && vehicle.make), str(vehicle && vehicle.model) ].join(" "));
    if (!targetLabel || !currentVehicleLabel) {
      return false;
    }
    return targetLabel === currentVehicleLabel || collapseFitmentToken(target.vehicleLabel) === collapseFitmentToken([ str(vehicle && vehicle.make), str(vehicle && vehicle.model) ].join(" "));
  }
  var readJson = window.AuxitoUtils.readJson;
  var writeJson = window.AuxitoUtils.writeJson;
  function removeStorageKeysByPrefixes(storage, prefixes) {
    var keys = [];
    var index;
    var key;
    if (!storage || !Array.isArray(prefixes) || !prefixes.length) {
      return;
    }
    try {
      for (index = 0; index < storage.length; index += 1) {
        key = storage.key(index);
        if (key && prefixes.some(function(prefix) {
          return key.indexOf(prefix) === 0;
        })) {
          keys.push(key);
        }
      }
      keys.forEach(function(item) {
        storage.removeItem(item);
      });
    } catch (error) {}
  }
  function cleanupLegacyValidationCache() {
    try {
      if (window.sessionStorage.getItem(FITMENT_VALIDATION_LEGACY_CLEANUP_KEY) === "1") {
        return;
      }
    } catch (error) {}
    removeStorageKeysByPrefixes(window.sessionStorage, FITMENT_VALIDATION_LEGACY_STORAGE_KEY_PREFIXES);
    removeStorageKeysByPrefixes(window.localStorage, FITMENT_VALIDATION_LEGACY_STORAGE_KEY_PREFIXES);
    try {
      window.sessionStorage.setItem(FITMENT_VALIDATION_LEGACY_CLEANUP_KEY, "1");
    } catch (error) {}
  }
  function readFitLocationParam() {
    try {
      return str(new URLSearchParams(window.location.search || "").get("fit_location"));
    } catch (error) {
      return "";
    }
  }
  function readFitParamValue() {
    try {
      return new URLSearchParams(window.location.search || "").get("fit") || "";
    } catch (error) {
      return "";
    }
  }
  function appendIncomingLampContext(url) {
    var position;
    var plug;
    var target;
    try {
      position = new URLSearchParams(window.location.search || "").get("position") || "";
      plug = new URLSearchParams(window.location.search || "").get("plug") || "";
      if (!position || !plug || !url) {
        return url;
      }
      target = new URL(url, window.location.href);
      if (!target.searchParams.has("position")) {
        target.searchParams.set("position", position);
      }
      if (!target.searchParams.has("plug")) {
        target.searchParams.set("plug", plug);
      }
      return target.pathname + target.search + target.hash;
    } catch (error) {
      return url;
    }
  }
  function dispatchVehicleContextChanged(vehicle) {
    var detail = {
      vehicle: vehicle || readCurrentVehicle() || null
    };
    if (typeof window.CustomEvent === "function") {
      window.dispatchEvent(new CustomEvent("auxito:vehicle-context-changed", {
        detail: detail
      }));
      return;
    }
    var event = document.createEvent("CustomEvent");
    event.initCustomEvent("auxito:vehicle-context-changed", false, false, detail);
    window.dispatchEvent(event);
  }
  function persistFitParamVehicle(vehicle) {
    var storage = vehicleUtils && typeof vehicleUtils.getVehicleStorage === "function" ? vehicleUtils.getVehicleStorage() : window.Auxito && window.Auxito.Vehicle && window.Auxito.Vehicle.Storage;
    var saved = null;
    if (!storage || typeof storage.addVehicle !== "function" || !vehicle) {
      return false;
    }
    saved = storage.addVehicle(vehicle);
    // 车型路径带来的配置（fit_headlight / fit_trim / fit_body，主管 2026-10-23 第 4 条）：只补访客在共用配置记忆里还没选的维度，
    // 不覆盖已选（含 Not sure）——刷新带旧参数的页面、别人分享的链接都不会改掉访客自己的选择（Astra / code-review 2.0.12 r18）
    var urlConfig = typeof fitmentEngine.readFitContextConfig === "function" ? fitmentEngine.readFitContextConfig() : {};
    var known = readVisitorConfig(vehicle);
    var fill = {};
    Object.keys(urlConfig).forEach(function(key) {
      if (!known[key]) {
        fill[key] = urlConfig[key];
      }
    });
    if (Object.keys(fill).length && typeof fitmentEngine.writeVehicleConfig === "function") {
      fitmentEngine.writeVehicleConfig(vehicle, readArtifactsConfig("search-result-artifacts-config"), fill);
    }
    if (vehicleUtils && typeof vehicleUtils.syncVehicleStorageUi === "function") {
      vehicleUtils.syncVehicleStorageUi({
        showSelectedState: true
      });
    }
    dispatchVehicleContextChanged(saved && saved.current ? saved.current : vehicle);
    return true;
  }
  async function initializeFitParamVehicle() {
    var fitValue = readFitParamValue();
    var result;
    if (!fitValue) {
      return false;
    }
    if (!vehicleUtils || typeof vehicleUtils.resolveVehicleFromFitParam !== "function") {
      openVehicleSelector();
      return false;
    }
    result = await vehicleUtils.resolveVehicleFromFitParam(fitValue);
    if (result && result.status === "matched" && result.vehicle) {
      return persistFitParamVehicle(result.vehicle);
    }
    openVehicleSelector({
      prefill: result && result.partial ? result.partial : null
    });
    return false;
  }
  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
  function normalizeContextPayload(payload) {
    if (!payload || typeof payload !== "object") {
      return null;
    }
    payload.sourceUrls = dedupe(payload.sourceUrls || []);
    payload.handles = dedupe(payload.handles || []);
    payload.artifactsSignature = str(payload.artifactsSignature);
    payload.filters = Object.assign({
      bodyType: "",
      trim: "",
      qualifier: ""
    }, payload.filters || {});
    return payload.sourceUrls.length ? payload : null;
  }
  function buildVehicleIdentity(vehicle) {
    return [ str(vehicle && vehicle.year), lower(vehicle && vehicle.make), lower(vehicle && vehicle.model), lower(vehicle && vehicle.trim) ].join("::");
  }
  function buildValidationArtifactsSignature(artifactsConfig) {
    var baseUrl = str(artifactsConfig && artifactsConfig.fitmentShardBaseUrl);
    var version = str(artifactsConfig && artifactsConfig.fitmentShardVersion);
    var mode = str(artifactsConfig && artifactsConfig.fitmentValidationMode || "legacy");
    var compactArtifactVersion = str(artifactsConfig && artifactsConfig.compactArtifactVersion);
    return baseUrl || version || compactArtifactVersion ? [ mode, baseUrl, compactArtifactVersion || version ].join("::") : "legacy";
  }
  function buildValidationArtifactsConfigs(artifactsConfig, compactArtifactsConfig) {
    var seen = new Set;
    return [ compactArtifactsConfig, artifactsConfig ].filter(function(config) {
      var signature = buildValidationArtifactsSignature(config);
      if (!config || seen.has(signature)) {
        return false;
      }
      seen.add(signature);
      return true;
    });
  }
  function readVisitorConfig(vehicle) {
    return typeof fitmentEngine.readVehicleConfig === "function" ? fitmentEngine.readVehicleConfig(vehicle, readArtifactsConfig("search-result-artifacts-config")) : {};
  }
  function buildValidationCacheKey(vehicle, artifactsConfig) {
    var config = readVisitorConfig(vehicle);
    return FITMENT_VALIDATION_STORAGE_KEY_PREFIX + "::" + buildValidationArtifactsSignature(artifactsConfig) + "::" + buildVehicleIdentity(vehicle) + "::" + state.product.handle + "::" + [ config.qualifier, config.trim, config.bodyType ].join("|");
  }
  function normalizeValidationResult(entry) {
    var normalizedStatus = str(entry && entry.status);
    if (!entry || typeof entry !== "object" || !normalizedStatus) {
      return null;
    }
    return {
      savedAt: Number(entry.savedAt || 0),
      status: normalizedStatus,
      payload: entry.payload ? normalizeContextPayload(entry.payload) : null,
      conditionLabels: Array.isArray(entry.conditionLabels) ? entry.conditionLabels.map(str).filter(Boolean) : [],
      conditionDimension: str(entry.conditionDimension),
      askOptions: Array.isArray(entry.askOptions) ? entry.askOptions.map(str).filter(Boolean) : [],
      askNotSure: str(entry.askNotSure),
      positions: Array.isArray(entry.positions) ? entry.positions.map(str).filter(Boolean) : [],
      notSure: str(entry.notSure),
      productSources: Array.isArray(entry.productSources) ? entry.productSources.map(str).filter(Boolean) : [],
      configLabel: str(entry.configLabel),
      configDimension: str(entry.configDimension),
      configChosen: !!entry.configChosen,
      configQualifier: str(entry.configQualifier),
      ledPending: !!entry.ledPending
    };
  }
  function readValidationResult(vehicle, artifactsConfig) {
    var cacheKey = buildValidationCacheKey(vehicle, artifactsConfig);
    var cached = normalizeValidationResult(readJson(window.sessionStorage, cacheKey) || readJson(window.localStorage, cacheKey));
    if (!cached || !cached.savedAt || Date.now() - cached.savedAt > FITMENT_VALIDATION_MAX_AGE_MS) {
      return null;
    }
    return cached;
  }
  function readValidationResultFromConfigs(vehicle, artifactsConfigs) {
    var configs = Array.isArray(artifactsConfigs) ? artifactsConfigs : [];
    var index;
    var cached;
    for (index = 0; index < configs.length; index += 1) {
      cached = readValidationResult(vehicle, configs[index]);
      if (cached) {
        return cached;
      }
    }
    return null;
  }
  function writeValidationResult(vehicle, result, artifactsConfig) {
    var cacheKey = buildValidationCacheKey(vehicle, artifactsConfig);
    var payload = normalizeValidationResult(result);
    if (!payload || (payload.status !== "fits" && payload.status !== "mismatch" && payload.status !== "conditional" && payload.status !== "unverified")) {
      return payload;
    }
    // fits 只在三状态补判确认后缓存（refineFitsWithStatus），避免补判失败时留下未经确认的 fits
    if (payload.status === "fits" && !(result && result.refined)) {
      return payload;
    }
    writeJson(window.sessionStorage, cacheKey, payload);
    writeJson(window.localStorage, cacheKey, payload);
    return payload;
  }
  function buildFitmentLocationGroups(records) {
    return (Array.isArray(records) ? records : []).map(function(record) {
      return {
        locationKey: str(record && record.locationKey),
        locationLabel: str(record && record.location),
        sourceUrls: buildRecordSourceUrls(record, createEmptyFilters())
      };
    }).filter(function(group) {
      return group.locationKey && group.sourceUrls.length;
    });
  }
  function buildRecordSourceUrls(record, filters) {
    var sourceUrls = [];
    if (!record) {
      return sourceUrls;
    }
    sourceUrls = getSourceUrlsForSelection(record, filters || createEmptyFilters());
    if (!sourceUrls.length) {
      sourceUrls = getSourceUrlsForSelection(record, createEmptyFilters());
    }
    if (record.directProductUrl) {
      sourceUrls.unshift(record.directProductUrl);
    }
    return dedupe(sourceUrls.map(normalizeSourceUrl).filter(Boolean));
  }
  function findMatchingEntryFilterValue(record, key, value) {
    var comparable = normalizeFitmentToken(value);
    var entries = Array.isArray(record && record.entries) ? record.entries : [];
    var index;
    var entryValue;
    if (!comparable) {
      return "";
    }
    for (index = 0; index < entries.length; index += 1) {
      entryValue = str(entries[index] && entries[index][key]);
      if (entryValue && entryValue !== "/" && normalizeFitmentToken(entryValue) === comparable) {
        return entryValue;
      }
    }
    return "";
  }
  function resolveVehicleFitmentFilters(record, vehicle) {
    var filters = createEmptyFilters();
    var trimValue = findMatchingEntryFilterValue(record, "trim", vehicle && vehicle.trim);
    if (trimValue) {
      filters.trim = trimValue;
    }
    return filters;
  }
  function buildRecordPayload(record, vehicle, filters, sourceUrls, handles, categoryRecords, artifactsConfig) {
    return normalizeContextPayload({
      savedAt: Date.now(),
      recordKind: str(record && record.kind || "dynamic"),
      artifactsSignature: buildValidationArtifactsSignature(artifactsConfig),
      queryCategory: str(record && record.queryCategory),
      categorySlug: str(record && record.categorySlug),
      locationKey: str(record && record.locationKey),
      locationLabel: str(record && record.location),
      year: str(vehicle && vehicle.year),
      make: str(vehicle && vehicle.make),
      model: str(vehicle && vehicle.model),
      filters: Object.assign(createEmptyFilters(), filters || {}),
      sourceUrls: dedupe(Array.isArray(sourceUrls) ? sourceUrls : []),
      handles: dedupe((Array.isArray(handles) ? handles : []).concat([ state.product.handle ])),
      locationGroups: buildFitmentLocationGroups(categoryRecords)
    });
  }
  function readStoredPdpFitmentOverrideVersion() {
    var storedValue = "";
    try {
      storedValue = str(window.sessionStorage.getItem(PDP_FITMENT_OVERRIDE_STORAGE_KEY));
    } catch (error) {}
    return PDP_FITMENT_VERSION_PATTERN.test(storedValue) ? storedValue : "";
  }
  function normalizePdpFitmentSource(source) {
    return str(source).toLowerCase() === PDP_FITMENT_SOURCE_THEME ? PDP_FITMENT_SOURCE_THEME : PDP_FITMENT_SOURCE_CDN;
  }
  function readStoredPdpFitmentOverrideSource() {
    var storedValue = "";
    try {
      storedValue = str(window.sessionStorage.getItem(PDP_FITMENT_SOURCE_STORAGE_KEY));
    } catch (error) {}
    return normalizePdpFitmentSource(storedValue);
  }
  function writeStoredPdpFitmentOverrideVersion(version) {
    try {
      if (!PDP_FITMENT_VERSION_PATTERN.test(str(version))) {
        window.sessionStorage.removeItem(PDP_FITMENT_OVERRIDE_STORAGE_KEY);
        return "";
      }
      window.sessionStorage.setItem(PDP_FITMENT_OVERRIDE_STORAGE_KEY, str(version));
      return str(version);
    } catch (error) {
      return PDP_FITMENT_VERSION_PATTERN.test(str(version)) ? str(version) : "";
    }
  }
  function writeStoredPdpFitmentOverrideSource(source) {
    var normalizedSource = normalizePdpFitmentSource(source);
    try {
      window.sessionStorage.setItem(PDP_FITMENT_SOURCE_STORAGE_KEY, normalizedSource);
    } catch (error) {}
    return normalizedSource;
  }
  function readPdpFitmentOverrideVersion() {
    var params;
    var queryValue = "";
    try {
      params = new URLSearchParams(window.location.search || "");
      if (params.has(PDP_FITMENT_OVERRIDE_QUERY_PARAM)) {
        queryValue = str(params.get(PDP_FITMENT_OVERRIDE_QUERY_PARAM));
        if (!queryValue || queryValue === "off" || queryValue === "clear" || queryValue === "0") {
          return writeStoredPdpFitmentOverrideVersion("");
        }
        if (PDP_FITMENT_VERSION_PATTERN.test(queryValue)) {
          return writeStoredPdpFitmentOverrideVersion(queryValue);
        }
      }
    } catch (error) {}
    return readStoredPdpFitmentOverrideVersion();
  }
  function readPdpFitmentOverrideSource() {
    var params;
    try {
      params = new URLSearchParams(window.location.search || "");
      if (params.has(PDP_FITMENT_SOURCE_QUERY_PARAM)) {
        return writeStoredPdpFitmentOverrideSource(params.get(PDP_FITMENT_SOURCE_QUERY_PARAM));
      }
    } catch (error) {}
    return readStoredPdpFitmentOverrideSource();
  }
  function readPdpFitmentSimulationConfig() {
    var parsed = fitmentEngine.parseJsonScriptById(PDP_FITMENT_SIMULATION_CONFIG_SCRIPT_ID, "pdp fitment simulation config");
    if (!parsed || typeof parsed !== "object") {
      return {};
    }
    return {
      fixtureUrl: str(parsed.fixture_url || parsed.fixtureUrl)
    };
  }
  function readPdpFitmentSimulationData() {
    var parsed = fitmentEngine.parseJsonScriptById(PDP_FITMENT_SIMULATION_DATA_SCRIPT_ID, "pdp fitment simulation data");
    return parsed && typeof parsed === "object" ? parsed : null;
  }
  function readInlineCurrentProductCompactSourceUrls(compactArtifactsConfig) {
    var parsed;
    var inlineArtifactVersion;
    var inlineHandle;
    var sourceUrls;
    var expectedArtifactVersion = str(compactArtifactsConfig && compactArtifactsConfig.compactArtifactVersion);
    if (compactCurrentProductSourceUrlsCache !== null && compactCurrentProductSourceUrlsCacheVersion === expectedArtifactVersion) {
      return compactCurrentProductSourceUrlsCache.slice();
    }
    parsed = fitmentEngine.parseJsonScriptById(PDP_FITMENT_CURRENT_PRODUCT_SOURCES_SCRIPT_ID, "pdp fitment current product sources");
    inlineArtifactVersion = str(parsed && (parsed.artifactVersion || parsed.artifact_version));
    inlineHandle = str(parsed && parsed.handle);
    sourceUrls = dedupe((Array.isArray(parsed && parsed.sourceUrls) ? parsed.sourceUrls : []).map(normalizeSourceUrl).filter(Boolean));
    compactCurrentProductSourceUrlsCacheVersion = expectedArtifactVersion;
    if (!expectedArtifactVersion || inlineArtifactVersion !== expectedArtifactVersion || !sourceUrls.length || !state.product || !state.product.handle || inlineHandle !== state.product.handle) {
      compactCurrentProductSourceUrlsCache = [];
      return [];
    }
    compactCurrentProductSourceUrlsCache = sourceUrls;
    return compactCurrentProductSourceUrlsCache.slice();
  }
  function normalizeCompactYearToken(year) {
    var normalizedYear = str(year).toLowerCase().replace(/\s+/g, "_").replace(/\+/g, "_");
    if (normalizedYear === "/" || normalizedYear === "universal") {
      return "unlimited";
    }
    return normalizedYear;
  }
  function resolveCompactFitmentArtifactsConfig(baseArtifactsConfig) {
    var overrideArtifactVersion = readPdpFitmentOverrideVersion();
    var configuredMode = str(baseArtifactsConfig && baseArtifactsConfig.fitmentValidationMode);
    var configuredArtifactVersion = str(baseArtifactsConfig && (baseArtifactsConfig.compactArtifactVersion || baseArtifactsConfig.fitmentShardVersion));
    var artifactVersion = overrideArtifactVersion || configuredArtifactVersion;
    var baseUrl;
    var source;
    var simulationConfig;
    var fixtureUrl = str(baseArtifactsConfig && baseArtifactsConfig.fixtureUrl);
    if (!PDP_FITMENT_VERSION_PATTERN.test(artifactVersion)) {
      return null;
    }
    if (!overrideArtifactVersion && configuredMode !== "pdp-compact" && configuredMode !== "pdp-compact-fixture") {
      return null;
    }
    source = overrideArtifactVersion ? readPdpFitmentOverrideSource() : normalizePdpFitmentSource(baseArtifactsConfig && baseArtifactsConfig.fitmentValidationSource);
    simulationConfig = readPdpFitmentSimulationConfig();
    baseUrl = normalizeArtifactsBaseUrl(str(baseArtifactsConfig && baseArtifactsConfig.fitmentShardBaseUrl) || "https://cdn.shopify.com/s/files/1/0012/8063/9049/files/");
    fixtureUrl = fixtureUrl || simulationConfig.fixtureUrl;
    if (source === PDP_FITMENT_SOURCE_THEME || configuredMode === "pdp-compact-fixture") {
      if (!fixtureUrl) {
        return null;
      }
      return {
        fitmentValidationMode: "pdp-compact-fixture",
        compactArtifactVersion: artifactVersion,
        fitmentShardBaseUrl: baseUrl,
        fitmentShardVersion: artifactVersion,
        fixtureUrl: fixtureUrl
      };
    }
    if (!baseUrl) {
      return null;
    }
    return {
      fitmentValidationMode: "pdp-compact",
      compactArtifactVersion: artifactVersion,
      fitmentShardBaseUrl: baseUrl,
      fitmentShardVersion: artifactVersion,
      sourceManifestIndexUrl: overrideArtifactVersion ? "" : str(baseArtifactsConfig && baseArtifactsConfig.sourceManifestIndexUrl),
      yearIndexUrl: resolveUrlAgainstBase("pdp-fitment-year-index-" + artifactVersion + ".json", baseUrl),
      yearGroupBaseUrl: baseUrl,
      handleSourcesUrl: resolveUrlAgainstBase("pdp-fitment-handle-sources-" + artifactVersion + ".json", baseUrl),
      sourceHandlesUrl: resolveUrlAgainstBase("pdp-fitment-source-handles-" + artifactVersion + ".json", baseUrl)
    };
  }
  function getCompactVehicleKey(vehicle) {
    return [ str(vehicle && vehicle.year), lower(vehicle && vehicle.make), lower(vehicle && vehicle.model) ].join("||");
  }
  function getCompactCacheKey(url) {
    return str(url);
  }
  function fetchCachedJson(url, cache) {
    var cacheKey = getCompactCacheKey(url);
    if (!cacheKey) {
      return Promise.reject(new Error("Missing compact artifact URL"));
    }
    if (cache.has(cacheKey)) {
      return cache.get(cacheKey);
    }
    cache.set(cacheKey, fetchJson(cacheKey).catch(function(error) {
      cache.delete(cacheKey);
      throw error;
    }));
    return cache.get(cacheKey);
  }
  async function fetchCompactFixturePayload(compactArtifactsConfig) {
    var inlinePayload = readPdpFitmentSimulationData();
    if (inlinePayload) {
      return inlinePayload;
    }
    return fetchCachedJson(compactArtifactsConfig && compactArtifactsConfig.fixtureUrl, compactFixturePayloadCache);
  }
  async function fetchCompactYearIndex(compactArtifactsConfig) {
    var manifest;
    var artifactUrl;
    if (compactArtifactsConfig && compactArtifactsConfig.fixtureUrl) {
      var fixturePayload = await fetchCompactFixturePayload(compactArtifactsConfig);
      var years = Object.keys(fixturePayload && fixturePayload.years && typeof fixturePayload.years === "object" ? fixturePayload.years : {}).sort(function(left, right) {
        return Number(right) - Number(left);
      });
      return {
        year_group_files: years.reduce(function(allYears, year) {
          allYears[year] = year;
          return allYears;
        }, {}),
        years: years
      };
    }
    manifest = await fetchVehicleLibraryManifest(compactArtifactsConfig);
    artifactUrl = getManifestArtifactUrl(manifest, "pdp-fitment-year-index") || compactArtifactsConfig && compactArtifactsConfig.yearIndexUrl;
    return fetchCachedJson(artifactUrl, compactYearIndexCache);
  }
  async function fetchCompactYearGroup(vehicle, compactArtifactsConfig) {
    var manifest;
    var artifactUrl;
    if (compactArtifactsConfig && compactArtifactsConfig.fixtureUrl) {
      var fixturePayload = await fetchCompactFixturePayload(compactArtifactsConfig);
      var yearKey = str(vehicle && vehicle.year);
      var yearEntry = fixturePayload && fixturePayload.years && typeof fixturePayload.years === "object" ? fixturePayload.years[yearKey] : null;
      return yearEntry && typeof yearEntry === "object" ? yearEntry : null;
    }
    var year = str(vehicle && vehicle.year);
    manifest = await fetchVehicleLibraryManifest(compactArtifactsConfig);
    artifactUrl = getManifestArtifactUrl(manifest, "pdp-fitment-year-group:" + normalizeCompactYearToken(year));
    if (artifactUrl) {
      return fetchCachedJson(artifactUrl, compactYearGroupCache);
    }
    var yearIndex = await fetchCompactYearIndex(compactArtifactsConfig);
    var fileName = str(yearIndex && yearIndex.year_group_files && yearIndex.year_group_files[year]);
    if (!fileName) {
      return null;
    }
    return fetchCachedJson(resolveUrlAgainstBase(fileName, compactArtifactsConfig && compactArtifactsConfig.yearGroupBaseUrl), compactYearGroupCache);
  }
  async function fetchCompactVehicleData(vehicle, compactArtifactsConfig) {
    var yearGroupPayload = await fetchCompactYearGroup(vehicle, compactArtifactsConfig);
    var vehicleKey = getCompactVehicleKey(vehicle);
    var vehicles = yearGroupPayload && yearGroupPayload.vehicles && typeof yearGroupPayload.vehicles === "object" ? yearGroupPayload.vehicles : null;
    if (!vehicles || !vehicleKey) {
      return null;
    }
    return vehicles[vehicleKey] || null;
  }
  async function fetchCompactHandleSourcesPayload(compactArtifactsConfig) {
    var manifest;
    var artifactUrl;
    if (compactArtifactsConfig && compactArtifactsConfig.fixtureUrl) {
      var fixturePayload = await fetchCompactFixturePayload(compactArtifactsConfig);
      return {
        handles: fixturePayload && fixturePayload.handle_sources && typeof fixturePayload.handle_sources === "object" ? fixturePayload.handle_sources : {}
      };
    }
    manifest = await fetchVehicleLibraryManifest(compactArtifactsConfig);
    artifactUrl = getManifestArtifactUrl(manifest, "pdp-fitment-handle-sources") || compactArtifactsConfig && compactArtifactsConfig.handleSourcesUrl;
    return fetchCachedJson(artifactUrl, compactHandleSourcesCache);
  }
  async function fetchCompactSourceHandlesPayload(compactArtifactsConfig) {
    var manifest;
    var artifactUrl;
    if (compactArtifactsConfig && compactArtifactsConfig.fixtureUrl) {
      var fixturePayload = await fetchCompactFixturePayload(compactArtifactsConfig);
      return {
        sources: fixturePayload && fixturePayload.source_handles && typeof fixturePayload.source_handles === "object" ? fixturePayload.source_handles : {}
      };
    }
    manifest = await fetchVehicleLibraryManifest(compactArtifactsConfig);
    artifactUrl = getManifestArtifactUrl(manifest, "pdp-fitment-source-handles") || compactArtifactsConfig && compactArtifactsConfig.sourceHandlesUrl;
    return fetchCachedJson(artifactUrl, compactSourceHandlesCache);
  }
  async function getCompactSourceUrlsForHandle(handle, compactArtifactsConfig) {
    var normalizedHandle = str(handle);
    if (state.product && normalizedHandle && normalizedHandle === state.product.handle) {
      var inlineSourceUrls = readInlineCurrentProductCompactSourceUrls(compactArtifactsConfig);
      if (inlineSourceUrls.length) {
        return inlineSourceUrls;
      }
    }
    var payload = await fetchCompactHandleSourcesPayload(compactArtifactsConfig);
    var entry = payload && payload.handles && payload.handles[normalizedHandle] ? payload.handles[normalizedHandle] : null;
    return dedupe((Array.isArray(entry && entry.sourceUrls) ? entry.sourceUrls : []).map(normalizeSourceUrl).filter(Boolean));
  }
  // 包 D:商品侧插头(与 sourceUrls 同一份 handle-sources payload,内存缓存不增请求)。
  // plugsState 只有 "confirmed"(人工审核确认)才参与窄化;其余一律视为未确认。
  async function getCompactPlugInfoForHandle(handle, compactArtifactsConfig) {
    var normalizedHandle = str(handle);
    if (!normalizedHandle) {
      return null;
    }
    var payload = await fetchCompactHandleSourcesPayload(compactArtifactsConfig);
    var entry = payload && payload.handles && payload.handles[normalizedHandle] ? payload.handles[normalizedHandle] : null;
    if (!entry) {
      return null;
    }
    return {
      plugs: dedupe((Array.isArray(entry.plugs) ? entry.plugs : []).map(normalizePlugcodeToken).filter(Boolean)),
      plugsState: str(entry.plugsState) === "confirmed" ? "confirmed" : "unconfirmed"
    };
  }
  async function getCompactHandlesForSourceUrl(sourceUrl, compactArtifactsConfig) {
    var payload = await fetchCompactSourceHandlesPayload(compactArtifactsConfig);
    var normalizedSourceUrl = normalizeSourceUrl(sourceUrl);
    var entry = payload && payload.sources && payload.sources[normalizedSourceUrl] ? payload.sources[normalizedSourceUrl] : null;
    return dedupe((Array.isArray(entry && entry.handles) ? entry.handles : []).map(str).filter(Boolean));
  }
  function buildCompactLocationGroups(category) {
    return (Array.isArray(category && category.locationGroups) ? category.locationGroups : []).map(function(group) {
      return {
        locationKey: str(group && group.locationKey),
        locationLabel: str(group && group.locationLabel),
        sourceUrls: dedupe((Array.isArray(group && group.sourceUrls) ? group.sourceUrls : []).map(normalizeSourceUrl).filter(Boolean))
      };
    }).filter(function(group) {
      return group.locationKey && group.sourceUrls.length;
    });
  }
  function buildCompactPayload(category, vehicle, productSourceUrls, compactArtifactsConfig, plugNarrowing) {
    var locationGroups = buildCompactLocationGroups(category);
    var firstGroup = locationGroups[0] || null;
    var payload = normalizeContextPayload({
      savedAt: Date.now(),
      recordKind: "compact",
      artifactsSignature: buildValidationArtifactsSignature(compactArtifactsConfig),
      queryCategory: str(category && category.queryCategory),
      categorySlug: str(category && category.categorySlug),
      locationKey: str(firstGroup && firstGroup.locationKey),
      locationLabel: str(firstGroup && firstGroup.locationLabel),
      year: str(vehicle && vehicle.year),
      make: str(vehicle && vehicle.make),
      model: str(vehicle && vehicle.model),
      filters: createEmptyFilters(),
      sourceUrls: dedupe((Array.isArray(productSourceUrls) ? productSourceUrls : []).concat(locationGroups.reduce(function(allUrls, group) {
        return allUrls.concat(Array.isArray(group && group.sourceUrls) ? group.sourceUrls : []);
      }, []))),
      handles: [ state.product.handle ],
      locationGroups: locationGroups
    });
    // 包 D:记录 plug 窄化结论(matched/unconfirmed),供缓存溯源与后续灯位背书
    if (payload && plugNarrowing) {
      payload.plugStatus = str(plugNarrowing.status);
      if (Array.isArray(plugNarrowing.matchedPlugs) && plugNarrowing.matchedPlugs.length) {
        payload.matchedPlugs = dedupe(plugNarrowing.matchedPlugs);
      }
    }
    return payload;
  }
  function buildVehicleSpecificProductPayload(target, vehicle, compactArtifactsConfig, vehicleData) {
    var categories = vehicleData && vehicleData.categories && typeof vehicleData.categories === "object" ? Object.keys(vehicleData.categories).map(function(key) {
      return vehicleData.categories[key];
    }) : [];
    var matchedCategory = null;
    var productSourceUrls = [ "/products/" + state.product.handle ];
    categories.some(function(category) {
      if (str(category && category.categorySlug) !== str(target && target.categorySlug)) {
        return false;
      }
      if (target && target.queryCategory && str(category && category.queryCategory) !== str(target.queryCategory)) {
        return false;
      }
      matchedCategory = category;
      return true;
    });
    if (matchedCategory) {
      return buildCompactPayload(matchedCategory, vehicle, productSourceUrls, compactArtifactsConfig);
    }
    return normalizeContextPayload({
      savedAt: Date.now(),
      recordKind: "vehicle-page",
      artifactsSignature: buildValidationArtifactsSignature(compactArtifactsConfig),
      queryCategory: str(target && target.queryCategory),
      categorySlug: str(target && target.categorySlug),
      locationKey: "",
      locationLabel: str(target && target.queryCategory),
      year: str(vehicle && vehicle.year),
      make: str(vehicle && vehicle.make),
      model: str(vehicle && vehicle.model),
      filters: createEmptyFilters(),
      sourceUrls: productSourceUrls,
      handles: [ state.product.handle ],
      locationGroups: []
    });
  }
  function resolveCompactCategoryMatch(vehicleData, productSourceUrls) {
    var categories = vehicleData && vehicleData.categories && typeof vehicleData.categories === "object" ? Object.keys(vehicleData.categories).map(function(key) {
      return vehicleData.categories[key];
    }) : [];
    var normalizedProductSourceUrls = dedupe((Array.isArray(productSourceUrls) ? productSourceUrls : []).map(normalizeSourceUrl).filter(Boolean));
    var matchedCategory = null;
    if (!normalizedProductSourceUrls.length) {
      return null;
    }
    categories.some(function(category) {
      var locationGroups = buildCompactLocationGroups(category);
      var matched = locationGroups.some(function(group) {
        return group.sourceUrls.some(function(sourceUrl) {
          return normalizedProductSourceUrls.indexOf(sourceUrl) > -1;
        });
      });
      if (!matched) {
        return false;
      }
      matchedCategory = category;
      return true;
    });
    return matchedCategory;
  }
  // 包 D:车型侧可信插头 = matchedCategory 全部 locationGroups 里 plugState=="single" 的 plug。
  // conflict/missing/composite_pending 一律不产生插头(fail-closed:不拿不确定数据做交集)。
  function collectCompactVehiclePlugs(category) {
    return dedupe((Array.isArray(category && category.locationGroups) ? category.locationGroups : []).map(function(group) {
      return group && str(group.plugState) === "single" ? normalizePlugcodeToken(group.plug) : "";
    }).filter(Boolean));
  }
  // 包 D plug 窄化(只产生"不确定",绝不直接产红):
  //   车型侧无可信插头 → 返回 null,fail-open 维持现有判定;
  //   商品侧未确认(unconfirmed/缺数据)→ "unconfirmed",fits 但不带灯位背书;
  //   两边 confirmed 无交集 → "no_intersection",由调用方走 verifyWithLegacy 回落复核;
  //   相交 → "matched",payload 记录 matched plug。
  async function resolveCompactPlugNarrowing(matchedCategory, compactArtifactsConfig) {
    var vehiclePlugs = collectCompactVehiclePlugs(matchedCategory);
    if (!vehiclePlugs.length) {
      return null;
    }
    var productPlugInfo = await getCompactPlugInfoForHandle(state.product.handle, compactArtifactsConfig);
    var productPlugs = productPlugInfo && productPlugInfo.plugsState === "confirmed" ? productPlugInfo.plugs : [];
    if (!productPlugs.length) {
      return { status: "unconfirmed", vehiclePlugs: vehiclePlugs, matchedPlugs: [] };
    }
    var matchedPlugs = vehiclePlugs.filter(function(plug) {
      return productPlugs.indexOf(plug) > -1;
    });
    if (!matchedPlugs.length) {
      return { status: "no_intersection", noIntersection: true, vehiclePlugs: vehiclePlugs, matchedPlugs: [] };
    }
    return { status: "matched", vehiclePlugs: vehiclePlugs, matchedPlugs: matchedPlugs };
  }
  async function resolveCompactFitmentValidation(vehicle, compactArtifactsConfig) {
    var vehicleData;
    var vehicleSpecificProduct = parseVehicleSpecificProductFitment(state.product);
    var productSourceUrls;
    var matchedCategory;
    try {
      if (vehicleSpecificProduct && !matchesVehicleSpecificProductFitment(vehicle, vehicleSpecificProduct)) {
        return writeValidationResult(vehicle, {
          savedAt: Date.now(),
          status: "mismatch",
          payload: null
        }, compactArtifactsConfig);
      }
      vehicleData = await fetchCompactVehicleData(vehicle, compactArtifactsConfig);
      if (!vehicleData && !vehicleSpecificProduct) {
        return {
          savedAt: Date.now(),
          status: "unresolved",
          payload: null
        };
      }
      if (vehicleSpecificProduct) {
        return writeValidationResult(vehicle, {
          savedAt: Date.now(),
          status: "fits",
          payload: buildVehicleSpecificProductPayload(vehicleSpecificProduct, vehicle, compactArtifactsConfig, vehicleData)
        }, compactArtifactsConfig);
      }
      productSourceUrls = await getCompactSourceUrlsForHandle(state.product.handle, compactArtifactsConfig);
      if (!productSourceUrls.length) {
        return {
          savedAt: Date.now(),
          status: "unresolved",
          payload: null
        };
      }
      matchedCategory = resolveCompactCategoryMatch(vehicleData, productSourceUrls);
      if (!matchedCategory) {
        // URL 交集不命中只是"索引没覆盖"的证据等级，不足以直接判红：
        // 不写缓存、标记 verifyWithLegacy，交由上层回落 live 集合扫描复核后才允许终判 mismatch
        return {
          savedAt: Date.now(),
          status: "mismatch",
          payload: null,
          verifyWithLegacy: true
        };
      }
      // 包 D:plug 窄化。confirmed 无交集同样不终判,标记 verifyWithLegacy 回落复核
      var plugNarrowing = await resolveCompactPlugNarrowing(matchedCategory, compactArtifactsConfig);
      if (plugNarrowing && plugNarrowing.noIntersection) {
        return {
          savedAt: Date.now(),
          status: "mismatch",
          payload: null,
          verifyWithLegacy: true
        };
      }
      return writeValidationResult(vehicle, {
        savedAt: Date.now(),
        status: "fits",
        payload: buildCompactPayload(matchedCategory, vehicle, productSourceUrls, compactArtifactsConfig, plugNarrowing)
      }, compactArtifactsConfig);
    } catch (error) {
      console.warn("Failed to resolve compact fitment validation for current PDP:", error);
      return {
        savedAt: Date.now(),
        status: "unresolved",
        payload: null
      };
    }
  }
  /*
   * 三状态补判（docs/fitment-status-handoff.zh-CN.md）：紧凑索引与集合扫描只知道「商品在不在这台车的数据里」，
   * 判为 fits 后再用完整车型数据走统一判断，分出 确定适配 / 仅适用部分配置（conditional）/ 尚未确认（unverified）。
   * 只有确定适配才显示 Fits On 并写 _fits_on；数据取不到时不显示 Fits On（unresolved）。
   */
  async function refineFitsWithStatus(vehicle, result, artifactsConfig, compactArtifactsConfig, matchedSourceUrls, scopeLocation) {
    var payload = result && result.payload;
    var productSources;
    var records;
    var outcome;
    var config;
    var configDimension;
    var scopeRecord = null;
    var handle = state.product.handle;
    if (!result || result.status !== "fits" || !payload || payload.recordKind === "vehicle-page" || typeof fitmentEngine.getUrlFitment !== "function") {
      return result;
    }
    // 读取层只做几百毫秒的快速重试、也不重试解析失败：这里失败后隔 1.5 秒再整体读一次，仍失败按「判断不了」（unresolved，不锁购买）
    try {
      for (var attempt = 0; !records; attempt += 1) {
        try {
          productSources = dedupe((Array.isArray(matchedSourceUrls) ? matchedSourceUrls : []).concat(compactArtifactsConfig ? await getCompactSourceUrlsForHandle(handle, compactArtifactsConfig) : []).map(normalizeSourceUrl).filter(Boolean));
          records = flattenSidebarGroups(buildDynamicSidebarGroups(await fetchDynamicFitmentYearData(str(vehicle && vehicle.year), artifactsConfig), {
            year: str(vehicle && vehicle.year),
            make: str(vehicle && vehicle.make),
            model: str(vehicle && vehicle.model)
          }));
        } catch (retryError) {
          if (attempt > 0) {
            throw retryError;
          }
          await new Promise(function(resolve) {
            window.setTimeout(resolve, 1500);
          });
        }
      }
    } catch (error) {
      // 读不到完整车型数据（网络中断等，很少见）：不能把补判前的 fits 当结论（会显示 Fits On、写进两小时缓存）；
      // 与其他数据读取失败一致按「判断不了」处理——不显示 Fits On、不写缓存、不锁购买（用户 2026-10-22 定）
      console.warn("Failed to refine fitment status for current PDP:", error);
      return {
        savedAt: Date.now(),
        status: "unresolved",
        payload: null
      };
    }
    // 只用访客确认过的配置（05 / 商品页共用的配置记忆），不读车型里存的 trim：
    // 旧版 05 会把只有一个选项的 Trim 自动写进车型，不代表访客确认过
    config = readVisitorConfig(vehicle);
    // 从灯位页（05 / 09）进来时网址带 fit_location：只按这个灯位判断（同一件商品在别的灯位适配，不代表这个灯位也适配）
    if (scopeLocation && typeof fitmentEngine.findLocationRecord === "function") {
      scopeRecord = fitmentEngine.findLocationRecord(records, scopeLocation, "LED Bulbs");
      if (!scopeRecord || !scopeRecord.fitmentStatus) {
        return null;
      }
      // 前一步找到商品所在的第一个集合就停了，可能不是这个灯位的集合：再读这个灯位自己列的集合（与 09 同一口径，运营 2026-10-22），
      // 商品确实在里面才算列了；读不到的集合不算（按尚未确认）
      await Promise.all(dedupe((scopeRecord.entries || []).reduce(function(urls, entry) {
        return urls.concat(entry.urls || []);
      }, []).map(normalizeSourceUrl).filter(function(url) {
        return isCollectionSourceUrl(url) && productSources.indexOf(url) === -1;
      })).map(function(url) {
        return fetchSourceProducts(url, { targetHandle: handle }).then(function(products) {
          if (products.some(function(product) {
            return product && product.handle === handle;
          })) {
            productSources.push(url);
          }
        }, function(error) {
          console.warn("Failed to read fitment source for current position:", url, error);
        });
      }));
    }
    outcome = fitmentEngine.getUrlFitment(records, function(url, entry, owner) {
      return (!scopeRecord || owner === scopeRecord) && (productSources.indexOf(normalizeSourceUrl(url)) > -1 || collectHandlesFromSourceUrls([ url ]).indexOf(handle) > -1);
    }, config);
    // 车型库这个灯位没列这件商品（如 09 按推荐规则放的商品）：这个灯位尚未确认，不能拿别的灯位的适配结论顶替
    if (scopeRecord && !outcome.matched) {
      return {
        savedAt: Date.now(),
        status: "unverified",
        payload: payload,
        productSources: productSources,
        positions: [ str(scopeRecord.location) ],
        notSure: "",
        configDimension: "",
        configLabel: "",
        configChosen: [ "qualifier", "trim", "bodyType" ].some(function(key) {
          return !!config[key];
        }),
        configQualifier: str(config.qualifier)
      };
    }
    // 这台车还没整理成三状态：照旧显示 Fits On
    if (outcome.legacy) {
      return result;
    }
    configDimension = [ "qualifier", "trim", "bodyType" ].filter(function(key) {
      return !!config[key] && (outcome.usedDimensions || []).indexOf(key) > -1;
    })[0] || "";
    if (outcome.result === "fits") {
      return Object.assign({}, result, {
        productSources: productSources,
        positions: scopeRecord ? [ str(scopeRecord.location) ] : [],
        configDimension: configDimension,
        configLabel: configDimension ? config[configDimension] : ""
      });
    }
    if (outcome.result === "ask") {
      return {
        savedAt: Date.now(),
        status: "conditional",
        payload: payload,
        productSources: productSources,
        positions: scopeRecord ? [ str(scopeRecord.location) ] : matchedLocations(records, productSources, handle),
        conditionDimension: outcome.ask ? outcome.ask.dimension : "",
        askOptions: outcome.ask ? outcome.ask.options || [] : [],
        askNotSure: outcome.ask && outcome.ask.notSureLabel || "",
        conditionLabels: dedupe((outcome.conditions || []).reduce(function(labels, item) {
          return labels.concat(item.labels || []);
        }, []))
      };
    }
    if (outcome.result === "unknown") {
      return {
        savedAt: Date.now(),
        status: "unverified",
        payload: payload,
        productSources: productSources,
        positions: scopeRecord ? [ str(scopeRecord.location) ] : matchedLocations(records, productSources, handle),
        notSure: outcome.notSure || "",
        configDimension: outcome.notSure || "",
        configLabel: outcome.notSure ? config[outcome.notSure] : "",
        ledPending: !!outcome.ledPending,
        // 访客选过任何配置：Check Fitment 轻提示写「selected vehicle configuration」那句，与 05 / 09 一致
        configChosen: [ "qualifier", "trim", "bodyType" ].some(function(key) {
          return !!config[key];
        }),
        configQualifier: str(config.qualifier)
      };
    }
    // 两份数据版本对不上（紧凑索引有、完整数据里没有）时不下结论；完整数据里有但条件不符才是不适配
    return outcome.matched ? {
      savedAt: Date.now(),
      status: "mismatch",
      payload: null,
      configDimension: configDimension,
      configLabel: configDimension ? config[configDimension] : ""
    } : { savedAt: Date.now(), status: "unresolved", payload: null };
  }
  // 这件商品在本车挂在哪些灯位（Check Fitment 弹窗里写灯位）
  function matchedLocations(records, productSources, handle) {
    return dedupe((records || []).filter(function(record) {
      return record && record.fitmentStatus && (record.entries || []).some(function(entry) {
        return (entry.urls || []).some(function(url) {
          return productSources.indexOf(normalizeSourceUrl(url)) > -1 || collectHandlesFromSourceUrls([ url ]).indexOf(handle) > -1;
        });
      });
    }).map(function(record) {
      return str(record.location);
    }).filter(Boolean));
  }
  async function resolveFitmentValidation(vehicle) {
    var artifactsConfig = readArtifactsConfig("search-result-artifacts-config");
    var compactArtifactsConfig = resolveCompactFitmentArtifactsConfig(artifactsConfig);
    var trace = {};
    var result = await resolveFitmentPresence(vehicle, trace);
    var refined;
    var scopeLocation = readFitLocationParam();
    var scoped;
    // 按灯位判断的结果不写缓存（缓存是整件商品对这台车的结论）
    if (scopeLocation && result && result.payload && [ "fits", "conditional", "unverified" ].indexOf(result.status) > -1) {
      scoped = await refineFitsWithStatus(vehicle, Object.assign({}, result, { status: "fits" }), artifactsConfig, compactArtifactsConfig, (trace.matchedSourceUrls || []).concat(result.productSources || []), scopeLocation);
      if (scoped) {
        return scoped;
      }
    }
    if (!result || result.status !== "fits" || result.fromCache) {
      return result;
    }
    refined = await refineFitsWithStatus(vehicle, result, artifactsConfig, compactArtifactsConfig, trace.matchedSourceUrls);
    buildValidationArtifactsConfigs(artifactsConfig, compactArtifactsConfig).forEach(function(config) {
      writeValidationResult(vehicle, Object.assign({}, refined, { refined: true }), config);
    });
    return refined;
  }
  async function resolveFitmentPresence(vehicle, trace) {
    var artifactsConfig;
    var compactArtifactsConfig;
    var validationArtifactsConfigs;
    var compactValidation;
    var cached;
    var yearData;
    var records;
    var candidateMatches = [];
    var hadSourceFailure = false;
    var hadIncompleteSourceScan = false;
    artifactsConfig = readArtifactsConfig("search-result-artifacts-config");
    compactArtifactsConfig = resolveCompactFitmentArtifactsConfig(artifactsConfig);
    validationArtifactsConfigs = buildValidationArtifactsConfigs(artifactsConfig, compactArtifactsConfig);
    cached = readValidationResultFromConfigs(vehicle, validationArtifactsConfigs);
    if (cached) {
      return Object.assign({}, cached, { fromCache: true });
    }
    if (compactArtifactsConfig) {
      compactValidation = await resolveCompactFitmentValidation(vehicle, compactArtifactsConfig);
      if (compactValidation && compactValidation.status === "fits") {
        return compactValidation;
      }
      // 带 verifyWithLegacy 的 compact mismatch（URL 索引未命中）不终判，继续走下方 live 扫描复核；
      // 其余 mismatch（车型专属商品标题门禁等）维持终判
      if (compactValidation && compactValidation.status === "mismatch" && !compactValidation.verifyWithLegacy) {
        return compactValidation;
      }
    }
    try {
      yearData = await fetchDynamicFitmentYearData(str(vehicle && vehicle.year), artifactsConfig);
      records = flattenSidebarGroups(buildDynamicSidebarGroups(yearData, {
        year: str(vehicle && vehicle.year),
        make: str(vehicle && vehicle.make),
        model: str(vehicle && vehicle.model)
      }));
      if (!records.length) {
        return {
          savedAt: Date.now(),
          status: "unresolved",
          payload: null
        };
      }
      records.forEach(function(record) {
        var preferredFilters = resolveVehicleFitmentFilters(record, vehicle);
        var filters = Object.assign(createEmptyFilters(), resolveEffectiveFilters(record, preferredFilters) || {});
        if (preferredFilters.trim && !filters.trim) {
          filters.trim = preferredFilters.trim;
        }
        var sourceUrls = buildRecordSourceUrls(record, filters);
        var directHandles = collectHandlesFromSourceUrls(sourceUrls);
        var categoryRecords = records.filter(function(item) {
          return str(item && item.categorySlug) === str(record && record.categorySlug) && str(item && item.queryCategory) === str(record && record.queryCategory);
        });
        if (directHandles.indexOf(state.product.handle) > -1) {
          candidateMatches.unshift({
            status: "fits",
            payload: buildRecordPayload(record, vehicle, filters, sourceUrls, directHandles, categoryRecords, artifactsConfig)
          });
          return;
        }
        if (sourceUrls.length) {
          candidateMatches.push({
            record: record,
            filters: filters,
            sourceUrls: sourceUrls,
            categoryRecords: categoryRecords
          });
        }
      });
      if (candidateMatches.length && candidateMatches[0].status === "fits" && candidateMatches[0].payload) {
        return writeValidationResult(vehicle, {
          savedAt: Date.now(),
          status: "fits",
          payload: candidateMatches[0].payload
        }, artifactsConfig);
      }
      if (!candidateMatches.length) {
        return {
          savedAt: Date.now(),
          status: "unresolved",
          payload: null
        };
      }
      candidateMatches.sort(function(left, right) {
        return left.sourceUrls.length - right.sourceUrls.length;
      });
      var sourceInspectionMap = await inspectCandidateSources(candidateMatches);
      for (var index = 0; index < candidateMatches.length; index += 1) {
        var candidate = candidateMatches[index];
        var matchedHandles = collectHandlesFromSourceUrls(candidate.sourceUrls);
        var matched = false;
        for (var sourceIndex = 0; sourceIndex < candidate.sourceUrls.length; sourceIndex += 1) {
          var sourceUrl = normalizeSourceUrl(candidate.sourceUrls[sourceIndex]);
          var inspection = sourceInspectionMap.get(sourceUrl);
          if (!inspection) {
            hadSourceFailure = true;
            continue;
          }
          matchedHandles = dedupe(matchedHandles.concat(Array.isArray(inspection.handles) ? inspection.handles : []));
          if (inspection.failed) {
            hadSourceFailure = true;
            continue;
          }
          if (inspection.scanComplete === false) {
            hadIncompleteSourceScan = true;
          }
          if ((inspection.handles || []).indexOf(state.product.handle) > -1) {
            matched = true;
            break;
          }
        }
        if (matched) {
          if (trace) {
            trace.matchedSourceUrls = [ sourceUrl ];
          }
          return writeValidationResult(vehicle, {
            savedAt: Date.now(),
            status: "fits",
            payload: buildRecordPayload(candidate.record, vehicle, candidate.filters, candidate.sourceUrls, matchedHandles, candidate.categoryRecords, artifactsConfig)
          }, artifactsConfig);
        }
      }
      if (hadSourceFailure || hadIncompleteSourceScan) {
        return {
          savedAt: Date.now(),
          status: "unresolved",
          payload: null
        };
      }
      return writeValidationResult(vehicle, {
        savedAt: Date.now(),
        status: "mismatch",
        payload: null
      }, artifactsConfig);
    } catch (error) {
      console.warn("Failed to validate fitment for current PDP:", error);
      return {
        savedAt: Date.now(),
        status: "unresolved",
        payload: null
      };
    }
  }
  function createContextSnapshot() {
    var currentVehicle = readCurrentVehicle();
    var context = {
      currentVehicle: currentVehicle,
      vehicleDisplay: buildVehicleDisplay(currentVehicle),
      payload: null,
      valid: false,
      fitsProduct: false,
      fitmentState: "prompt",
      validationPending: false,
      showPendingIndicator: false
    };
    if (!currentVehicle) {
      return context;
    }
    if (isUniversalProduct(state.product) || isStaticFitmentExemptProduct(state.product)) {
      context.fitmentState = "selected";
      return context;
    }
    // 入口无关原则：上游页面写入的 fitment context 只是"用户来自哪里"的线索，
    // 不再直接授权 fits；直达 PDP 与车型/灯位路径统一走 resolveFitmentValidation 判定
    context.fitmentState = "selected";
    context.validationPending = true;
    return context;
  }
  async function resolveContext(context) {
    context = context || createContextSnapshot();
    if (!context.validationPending || !context.currentVehicle) {
      return context;
    }
    var validation = await resolveFitmentValidation(context.currentVehicle);
    context.validationPending = false;
    context.configLabel = validation && validation.configLabel || "";
    context.configDimension = validation && validation.configDimension || "";
    if (validation && validation.status === "fits" && validation.payload) {
      context.payload = validation.payload;
      context.valid = true;
      context.fitsProduct = true;
      context.fitmentState = "fits";
      // 从灯位页进来（fit_location）时 Fits On 下也写灯位（主管 2026-10-23 第 4 条）
      context.positions = validation.positions || [];
      return context;
    }
    if (validation && (validation.status === "conditional" || validation.status === "unverified")) {
      context.payload = validation.payload || null;
      context.fitmentState = validation.status;
      context.conditionLabels = validation.conditionLabels || [];
      context.conditionDimension = validation.conditionDimension || "";
      context.askOptions = validation.askOptions || [];
      context.askNotSure = validation.askNotSure || "";
      context.positions = validation.positions || [];
      context.notSure = validation.notSure || "";
      context.configChosen = !!validation.configChosen;
      context.configQualifier = validation.configQualifier || "";
      context.ledPending = !!validation.ledPending;
      if (validation.status === "unverified") {
        context.factoryBulbs = await lookupFactoryBulbs(context.currentVehicle, context.positions);
        context.bulbGuideUrl = context.factoryBulbs.length ? "" : await lookupBulbGuideUrl(context.currentVehicle);
      }
      return context;
    }
    context.fitmentState = validation && validation.status === "mismatch" ? "mismatch" : "selected";
    return context;
  }
  // 尚未确认时给访客核对用的原厂灯泡型号：取紧凑车型数据里该灯位唯一确定的插头（有冲突 / 缺数据不显示）
  async function lookupFactoryBulbs(vehicle, positions) {
    var wanted = (positions || []).map(lower).filter(Boolean);
    var vehicleData;
    var bulbs = [];
    if (!wanted.length) {
      return [];
    }
    // 从 09 进来时链接带着该行的原厂型号（fit_bulb），只认单一灯位
    if (wanted.length === 1 && readFitLocationParam() && readFitBulbParam()) {
      return [ readFitBulbParam() ];
    }
    try {
      vehicleData = await fetchCompactVehicleData(vehicle, resolveCompactFitmentArtifactsConfig(readArtifactsConfig("search-result-artifacts-config")));
    } catch (error) {
      return [];
    }
    Object.keys(vehicleData && vehicleData.categories || {}).forEach(function(key) {
      (vehicleData.categories[key].locationGroups || []).forEach(function(group) {
        if (group && str(group.plugState) === "single" && wanted.indexOf(lower(group.locationLabel)) > -1) {
          bulbs.push(normalizePlugcodeToken(group.plug));
        }
      });
    });
    return dedupe(bulbs.filter(Boolean));
  }
  function readFitBulbParam() {
    var value = str(new URLSearchParams(window.location.search || "").get("fit_bulb"));
    return /^[A-Za-z0-9][A-Za-z0-9 .\/-]{0,23}$/.test(value) ? value.toUpperCase() : "";
  }
  // 查不到原厂型号时给这台车的 06 灯泡尺寸页（与 /pages/search、品牌页选车同一份 06 清单）
  async function lookupBulbGuideUrl(vehicle) {
    var self = document.querySelector('script[src*="auxito-product-fitment.js"]');
    var flat = function(value) {
      return lower(value).replace(/[^a-z0-9]/g, "");
    };
    var directory;
    var page;
    var query;
    if (!self || !vehicle) {
      return "";
    }
    try {
      directory = await fetchCachedJson(self.src.replace(/auxito-product-fitment\.js[^/]*$/, "auxito-bsg2-directory.json"), bulbGuideDirectoryCache);
    } catch (error) {
      return "";
    }
    page = (directory && directory.pages || []).filter(function(entry) {
      // 与 06 选车卡同一匹配规则：车型库品牌（第 6 列）缺省时用显示品牌，车型含显示名（第 3 列）与车型库别名（2.0.12 审查）
      return (flat(entry[5] || entry[1]) === flat(vehicle.make) || flat(entry[1]) === flat(vehicle.make)) && (entry[6] || []).concat([ entry[2] ]).some(function(model) {
        return flat(model) === flat(vehicle.model);
      }) && (entry[3] || []).indexOf(Number(vehicle.year)) > -1;
    })[0];
    if (!page) {
      return "";
    }
    query = new URLSearchParams({ year: str(vehicle.year), model: page[2] });
    if (!/^\d/.test(page[0])) {
      query.set("view", "bulb-size-guide-v2");
    }
    return "/pages/" + page[0] + "?" + query.toString();
  }
  var bulbGuideDirectoryCache = new Map();
  function positionText(context) {
    var positions = Array.isArray(context.positions) ? context.positions.filter(Boolean) : [];
    return positions.length ? (positions.length > 1 ? "Positions: " : "Position: ") + positions.join(", ") : "";
  }
  // 「Contact us to confirm」：联系页按网址参数预填车型、灯位、商品（sections/auxito-contact-page.liquid）
  function buildContactUrl(context) {
    var params = new URLSearchParams();
    params.set("fitment_vehicle", context.vehicleDisplay);
    if ((context.positions || []).length) {
      params.set("fitment_position", context.positions.join(", "));
    }
    params.set("fitment_product", state.product.handle);
    if (state.product.title) {
      params.set("fitment_title", state.product.title);
    }
    if ((context.factoryBulbs || []).length) {
      params.set("fitment_bulb", context.factoryBulbs.join(" / "));
    }
    return "/pages/get-in-touch?" + params.toString();
  }
  // 尚未确认的核实区（主管 2026-10-10 选定的最小闭环）：原厂灯泡尺寸 + 一句核对说明 + Contact us to confirm
  function buildVerifyMarkup(context) {
    var bulbs = context.factoryBulbs || [];
    return '<div class="auxito-fits-verify">' + (bulbs.length ? '<div class="auxito-fits-verify__bulb">Factory bulb size: <strong>' + escapeHtml(bulbs.join(" / ")) + "</strong></div>" : "") + '<p class="auxito-fits-verify__note">' + escapeHtml((typeof fitmentEngine.checkFitmentNote !== "function" ? fitmentEngine.CHECK_FITMENT_NOTE : context.ledPending ? fitmentEngine.checkFitmentNote({}, { ledPending: true }) : context.notSure && !context.configQualifier ? fitmentEngine.CHECK_FITMENT_NOTE : fitmentEngine.checkFitmentNote({ qualifier: context.configQualifier, trim: context.notSure || context.configLabel || context.configChosen ? "chosen" : "" }, { headlampPosition: !(context.positions || []).length || (context.positions || []).some(function(location) { return /beam|head\s*(lamp|light)/i.test(location) && !/indicator/i.test(location); }) })) || "Please confirm your current bulb base or headlight assembly before ordering.") + "</p>" + '<div class="auxito-fits-verify__actions">' + (!bulbs.length && context.bulbGuideUrl ? '<a class="auxito-fits-verify__contact" href="' + escapeHtml(context.bulbGuideUrl) + '">Find your factory bulb size</a>' : "") + '<a class="auxito-fits-verify__contact" href="' + escapeHtml(buildContactUrl(context)) + '">Contact us to confirm</a></div></div>';
  }
  // 运营原话第 3 条：CONDITIONAL 提示补选对应配置。选项来自本车车型数据，选过的配置与 05 共用
  var CONFIG_QUESTIONS = {
    qualifier: "Select your factory headlight type to verify fitment.",
    trim: "Select your trim to verify fitment.",
    bodyType: "Select your body style to verify fitment."
  };
  var CONFIG_RESET_LABELS = {
    qualifier: "Change headlight type",
    trim: "Change trim",
    bodyType: "Change body style"
  };
  function buildConfigQuestionMarkup(context) {
    var dimension = context.conditionDimension;
    var options = Array.isArray(context.askOptions) ? context.askOptions : [];
    if (!CONFIG_QUESTIONS[dimension] || !options.length) {
      return "";
    }
    // 「Not sure」：访客不确定自己的配置 → 尚未确认，走 Check Fitment 人工核实（主管 2026-10-10，不再用含糊的 Other）
    return '<div class="auxito-fits-config" data-fitment-config-dimension="' + escapeHtml(dimension) + '">' + '<div class="auxito-fits-config__question">' + escapeHtml(CONFIG_QUESTIONS[dimension]) + "</div>" + '<div class="auxito-fits-config__options">' + options.concat(context.askNotSure ? [ context.askNotSure ] : []).map(function(option) {
      return '<button type="button" class="auxito-fits-config__option" data-fitment-config-value="' + escapeHtml(option) + '">' + escapeHtml(typeof fitmentEngine.configOptionLabel === "function" ? fitmentEngine.configOptionLabel(dimension, option) : option) + "</button>";
    }).join("") + "</div>" + '<p class="auxito-fits-config__note">' + escapeHtml(CONFIG_ASK_NOTE) + "</p></div>";
  }
  // 要先选配置时不挡购买（运营 2026-10-26），选项下方一行轻提示
  var CONFIG_ASK_NOTE = "You can still order now. Please confirm your current bulb base or headlight assembly before ordering.";
  function buildConfigResetMarkup(context) {
    if (!context.configLabel || !CONFIG_RESET_LABELS[context.configDimension]) {
      return "";
    }
    return '<button type="button" class="auxito-fits-config__reset" data-fitment-config-reset="' + escapeHtml(context.configDimension) + '">' + escapeHtml(CONFIG_RESET_LABELS[context.configDimension]) + "</button>";
  }
  function saveVisitorConfig(patch) {
    var vehicle = readCurrentVehicle();
    if (!vehicle || typeof fitmentEngine.writeVehicleConfig !== "function") {
      return;
    }
    fitmentEngine.writeVehicleConfig(vehicle, readArtifactsConfig("search-result-artifacts-config"), patch);
    // 访客在商品页改了配置：去掉网址里对应的 fit_* 参数，地址栏与共用记忆一致（与 05 同一做法）
    try {
      var url = new URL(window.location.href);
      var names = { qualifier: "fit_headlight", trim: "fit_trim", bodyType: "fit_body" };
      Object.keys(patch || {}).forEach(function(key) {
        if (names[key]) {
          url.searchParams.delete(names[key]);
        }
      });
      window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
    } catch (error) {}
    refreshFitment();
  }
  // 「仅适用部分配置」的说明：灯组写 with / without，Trim 和车身写 only
  function buildConditionText(context) {
    var labels = Array.isArray(context.conditionLabels) ? context.conditionLabels : [];
    if (!labels.length) {
      return context.vehicleDisplay;
    }
    if (context.conditionDimension === "trim") {
      return context.vehicleDisplay + " · " + labels.join(" or ") + " trim only";
    }
    if (context.conditionDimension === "bodyType") {
      return context.vehicleDisplay + " · " + labels.join(" or ") + " only";
    }
    return context.vehicleDisplay + " " + labels.map(function(label) {
      return /^without /i.test(label) ? "without " + label.slice(8) : "with " + label;
    }).join(" or ");
  }
  function buildContextKey(context) {
    return [ str(context.fitmentState), context.vehicleDisplay, state.product.handle, context.payload ? str(context.payload.recordKind) : "", context.payload ? str(context.payload.artifactsSignature) : "", context.payload ? str(context.payload.locationKey) : "", context.payload ? (context.payload.sourceUrls || []).join("|") : "", context.payload ? (context.payload.handles || []).join("|") : "" ].join("::");
  }
  function renderFitsBanner(context) {
    var markup;
    if (!context.currentVehicle) {
      markup = buildFitsMarkup("prompt", "Vehicle Check", "Select your vehicle to verify fitment.", "Select Vehicle");
    } else if (context.validationPending && context.showPendingIndicator) {
      markup = buildFitsMarkup("checking", "Checking Fitment", context.vehicleDisplay, "Change");
    } else if (context.fitmentState === "fits" && context.fitsProduct) {
      markup = buildFitsMarkup("vehicle", "Fits On", context.vehicleDisplay + (context.configLabel ? " · " + context.configLabel : ""), "Change", positionText(context)) + buildConfigResetMarkup(context);
    } else if (context.fitmentState === "conditional" && (context.askOptions || []).length) {
      // 还没选配置：不写「with Halogen Headlights」，只写车型、灯位，并请访客选择（主管 2026-10-10）
      markup = buildFitsMarkup("conditional", CONFIG_SELECT_LABEL, context.vehicleDisplay, "Change", positionText(context)) + buildConfigQuestionMarkup(context);
    } else if (context.fitmentState === "conditional") {
      markup = buildFitsMarkup("conditional", "Fits If Equipped", buildConditionText(context), "Change", positionText(context));
    } else if (context.fitmentState === "unverified") {
      markup = buildFitsMarkup("unverified", "Check Fitment", context.vehicleDisplay + (context.notSure ? " \u00b7 " + (CONFIG_NOT_SURE_TEXT[context.notSure] || "configuration not confirmed") : ""), "Change", positionText(context)) + buildVerifyMarkup(context) + (context.notSure ? buildConfigResetMarkup(context) : "");
    } else if (context.fitmentState === "mismatch") {
      markup = buildFitsMarkup("mismatch", "", "Does Not Fit Your " + context.vehicleDisplay + (context.configLabel ? " with " + context.configLabel : ""), "Change") + buildConfigResetMarkup(context);
    } else {
      markup = buildFitsMarkup("vehicle", "Selected Vehicle", context.vehicleDisplay, "Change");
    }
    dom.fitsTargets.forEach(function(node) {
      node.innerHTML = markup;
    });
    syncFitsOnProperty(context);
    applyPurchaseLock(context);
  }
  // 邮件营销（Omnisend 弃购）读取的隐藏商品行属性：只在判定 Fits 时随加购提交，
  // 值自带 "Fits On " 前缀，邮件里没值时整行为空。
  // 只用年份 / 品牌 / 车型拼（判定 Fits 时三者已与车型库对上）；不用 display / trim——它们可能来自网址 fit 参数的任意文字，不能写进订单（PR #56 审查）
  function fitsOnVehicleText(vehicle) {
    if (!vehicle) return "";
    var year = String(vehicle.year || "").trim();
    var make = String(vehicle.make || "").trim().replace(/\s+/g, " ");
    var model = String(vehicle.model || "").trim().replace(/\s+/g, " ");
    var safe = /^[A-Za-z0-9][A-Za-z0-9 .&()\/'-]{0,40}$/;
    if (!/^(19|20)\d{2}$/.test(year) || !safe.test(make) || !safe.test(model) || /\d{5,}/.test(make + " " + model)) return "";
    // 车型库写法 Silverado 2500 Hd → HD（LD / LTD 同理）
    model = model.replace(/\b(hd|ld|ltd)\b/gi, function(w) { return w.toUpperCase(); });
    return year + " " + make + " " + model;
  }
  function syncFitsOnProperty(context) {
    var text = context && context.currentVehicle && !context.validationPending && context.fitmentState === "fits" && context.fitsProduct ? fitsOnVehicleText(context.currentVehicle) : "";
    var fits = !!text;
    var value = fits ? "Fits On " + text : "";
    document.querySelectorAll('.product--section input[data-auxito-fits-on]').forEach(function(input) {
      input.value = value;
      input.disabled = !fits;
    });
  }
  var CONFIG_NOT_SURE_TEXT = {
    qualifier: "headlight type not confirmed",
    trim: "trim not confirmed",
    bodyType: "body style not confirmed"
  };
  // 要先选配置时的主按钮，与 05 商品卡同一叫法（运营 2026-10-21，原为 Select Headlight Type / Select Trim / Select Body Style）
  var CONFIG_SELECT_LABEL = "Confirm Your Configuration";
  /*
   * 购买锁（主管 2026-10-10；10-23 起「尚未确认」、10-26 起「要先选配置」都不再锁，运营 2026-10-26）：
   * 现在只剩「已选车型、结论还没回来」时的 Checking Fitment（只拦截加购点击）。没选车型（Google / 广告 / 集合页直达）照常购买。
   */
  function getPurchaseLock(context) {
    if (!context || !context.currentVehicle) {
      return null;
    }
    // 已选车型、结论还没回来：不在结论前放开加购（2.0.12 审查）。同一台车已有锁就保留原锁；
    // 否则 Checking Fitment…（只拦截加购点击，不隐藏按钮）；超过 30 秒仍没结论（网络很慢 / 请求挂起）按读取失败处理，放开（用户 2026-10-22 定）
    if (context.validationPending) {
      if (state.purchaseLock && state.purchaseLockVehicle === vehicleLockKey(context.currentVehicle) && state.purchaseLock.kind !== "checking") {
        return state.purchaseLock;
      }
      return Date.now() - (state.pendingSince || Date.now()) < PENDING_LOCK_MS ? { kind: "checking", label: "Checking Fitment\u2026" } : null;
    }
    // 待核实（Check Fitment，主管 2026-10-23 最终确认第 2 条）与要先选配置（Confirm Your Configuration，运营 2026-10-26）都不锁购买，
    // 只在上方显示配置选项与轻提示
    return null;
  }
  function ensureLockStyle() {
    var style;
    if (document.getElementById("auxito-fitment-lock-style")) {
      return;
    }
    style = document.createElement("style");
    style.id = "auxito-fitment-lock-style";
    style.textContent = "html.auxito-fitment-locked .product--section .product-form--atc [data-product-atc],html.auxito-fitment-locked .product--section .product-form--atc .shopify-payment-button,html.auxito-fitment-locked .product--section .product-form--atc .sticky-product-handle,html.auxito-fitment-locked #stickyBottomBar .sticky-bottom-bar__btn-row,html.auxito-fitment-locked [data-auxito-fitment-lockable]{display:none!important}" + ".auxito-fitment-lock-cta{display:none;width:100%;min-height:48px;margin:0;padding:12px 20px;border:1px solid #1d1d1f;border-radius:4px;background:#fff;color:#1d1d1f;font:inherit;font-size:16px;font-weight:700;line-height:1.3;text-align:center;cursor:pointer}" + "html.auxito-fitment-locked .auxito-fitment-lock-cta{display:block}" + ".auxito-fitment-lock-cta:hover{background:#ffc700;border-color:#ffc700}" + "#stickyBottomBar .auxito-fitment-lock-cta{min-height:44px;font-size:15px}";
    document.head.appendChild(style);
  }
  function lockCtaHosts() {
    var hosts = [];
    // 只锁本页主商品：推荐商品的 Choose options 弹窗（.modal-content 里的 .product-form--atc）不受影响（2.0.12 审查）
    document.querySelectorAll(".product--section .product-form--atc").forEach(function(node) {
      hosts.push({ node: node, where: "afterbegin" });
    });
    document.querySelectorAll("#stickyBottomBar .sticky-bottom-bar__body").forEach(function(node) {
      hosts.push({ node: node, where: "beforeend" });
    });
    return hosts;
  }
  function onLockCtaClick(event) {
    var lock = state.purchaseLock;
    var context = state.context;
    var banner;
    event.preventDefault();
    if (!lock || !context) {
      return;
    }
    // 尚未确认：回到上方的核实区（原厂灯泡尺寸 + Contact us to confirm）
    banner = document.querySelector(".auxito-fits-verify") || document.querySelector(".auxito-fits-info");
    if (banner) {
      banner.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
  var PENDING_LOCK_MS = 30000;
  function vehicleLockKey(vehicle) {
    return vehicle ? [ vehicle.year, vehicle.make, vehicle.model ].map(lower).join("|") : "";
  }
  function applyPurchaseLock(context) {
    var lock = getPurchaseLock(context);
    state.purchaseLock = lock;
    state.purchaseLockVehicle = lock ? vehicleLockKey(context && context.currentVehicle) : "";
    // 等结论期间（checking）只拦截加购点击 / 提交，不隐藏购买按钮（每次进商品页按钮不闪）
    if (!lock || lock.kind === "checking") {
      document.documentElement.classList.remove("auxito-fitment-locked");
      return;
    }
    ensureLockStyle();
    lockCtaHosts().forEach(function(host) {
      var button = host.node.querySelector(":scope > .auxito-fitment-lock-cta");
      if (!button) {
        button = document.createElement("button");
        button.type = "button";
        button.className = "auxito-fitment-lock-cta";
        button.addEventListener("click", onLockCtaClick);
        host.node.insertAdjacentElement(host.where, button);
      }
      button.textContent = lock.label;
    });
    document.documentElement.classList.add("auxito-fitment-locked");
  }
  // 锁定时拦截加购：表单提交、悬浮栏按钮、Shop Pay（兜底，防止样式没生效或脚本触发）
  function guardLockedPurchase(event) {
    var target = event.target;
    if (!state.purchaseLock || !target || !target.closest) {
      return;
    }
    if (event.type === "submit" ? target.matches("form[action*='/cart/add']") && !!target.closest(".product--section") : target.closest("#stickyAtcBtn, #stickyBuyNow, .product--section .product-form--atc [data-product-atc], .product--section .product-form--atc .shopify-payment-button")) {
      event.preventDefault();
      event.stopImmediatePropagation();
      onLockCtaClick(event);
    }
  }
  // 挂在 window 捕获阶段：早于侧边购物车（auxito-cart-drawer.js 在 document 捕获阶段接管加购提交）等全部加购脚本
  window.addEventListener("submit", guardLockedPurchase, true);
  window.addEventListener("click", guardLockedPurchase, true);
  function buildFitsMarkup(kind, eyebrow, value, linkLabel, detail) {
    var textClass = kind === "prompt" ? "auxito-fits-info__prompt" : kind === "mismatch" ? "auxito-fits-info__alert" : "auxito-fits-info__value";
    var eyebrowMarkup = eyebrow ? '<div class="auxito-fits-info__eyebrow">' + escapeHtml(eyebrow) + "</div>" : "";
    var iconMarkup = kind === "mismatch" ? FITMENT_MISMATCH_ICON : kind === "checking" ? FITMENT_PENDING_SPINNER : FITS_ICON;
    var actionMarkup = !str(linkLabel) ? "" : '<button class="auxito-fits-info__link" type="button" data-fitment-open-vehicle-modal><span>' + escapeHtml(linkLabel) + "</span></button>";
    return "" + '<div class="auxito-fits-info auxito-fits-info--' + kind + '">' + '<div class="auxito-fits-info__main">' + '<span class="auxito-fits-info__icon auxito-fits-info__icon--' + kind + '">' + iconMarkup + "</span>" + '<div class="auxito-fits-info__text">' + eyebrowMarkup + '<div class="' + textClass + '">' + escapeHtml(value) + "</div>" + (detail ? '<div class="auxito-fits-info__detail">' + escapeHtml(detail) + "</div>" : "") + "</div>" + "</div>" + actionMarkup + "</div>";
  }
  function clearPendingFitmentUiTimer() {
    if (!state.pendingFitmentUiTimer) {
      return;
    }
    window.clearTimeout(state.pendingFitmentUiTimer);
    state.pendingFitmentUiTimer = 0;
  }
  function schedulePendingFitmentUi(context, token) {
    clearPendingFitmentUiTimer();
    if (!context || !context.validationPending) {
      return;
    }
    state.pendingFitmentUiTimer = window.setTimeout(function() {
      state.pendingFitmentUiTimer = 0;
      if (token !== state.activeLoadToken || !state.context || !state.context.validationPending) {
        return;
      }
      state.context.showPendingIndicator = true;
      renderFitsBanner(state.context);
    }, FITMENT_PENDING_UI_DELAY_MS);
  }
  function openVehicleSelector(options) {
    var selectorApi = window.Auxito && window.Auxito.Vehicle && window.Auxito.Vehicle.Selector ? window.Auxito.Vehicle.Selector : null;
    if (selectorApi && typeof selectorApi.openModal === "function") {
      selectorApi.openModal(Object.assign({
        source: "fitment"
      }, options || {}));
      return;
    }
    var trigger = document.querySelector(".vehicle-selection-module");
    if (trigger) {
      trigger.setAttribute("data-vehicle-modal-source", "fitment");
    }
    if (trigger && typeof trigger.click === "function") {
      trigger.click();
      trigger.removeAttribute("data-vehicle-modal-source");
    }
  }
  function showStatus(message, type) {
    if (!dom.status) {
      return;
    }
    if (!str(message)) {
      hideStatus();
      return;
    }
    dom.status.hidden = false;
    dom.status.textContent = str(message);
    dom.status.setAttribute("data-status-type", str(type || "info"));
  }
  function hideStatus() {
    if (!dom.status) {
      return;
    }
    dom.status.hidden = true;
    dom.status.textContent = "";
    dom.status.removeAttribute("data-status-type");
  }
  function hideSection() {
    state.recommendations = [];
    dom.section.hidden = true;
    dom.section.classList.remove("auxito-product-fitment--bootstrap");
    dom.section.classList.remove("auxito-product-fitment--loading");
    dom.track.innerHTML = "";
    if (dom.controls) {
      dom.controls.hidden = true;
    }
    hideStatus();
  }
  function showLoading(context) {
    var items = [];
    var groups = context && context.payload ? context.payload.locationGroups : null;
    var index;
    var skeletonCount = Array.isArray(groups) && groups.length ? Math.min(groups.length * DYNAMIC_PER_LOCATION_LIMIT, MAX_PRODUCTS_TOTAL) : DEFAULT_SKELETON_CARD_COUNT;
    dom.section.hidden = false;
    dom.section.classList.add("auxito-product-fitment--bootstrap");
    dom.section.classList.add("auxito-product-fitment--loading");
    if (dom.title) {
      dom.title.textContent = context.vehicleDisplay ? "Recommended for Your " + context.vehicleDisplay : "Recommended for Your Vehicle";
    }
    for (index = 0; index < skeletonCount; index += 1) {
      items.push('<article class="auxito-product-fitment__card auxito-product-fitment__skeleton" aria-hidden="true"><div class="auxito-product-fitment__skeleton-media"></div><div class="auxito-product-fitment__body"><div class="auxito-product-fitment__skeleton-line auxito-product-fitment__skeleton-line--title"></div><div class="auxito-product-fitment__skeleton-line"></div><div class="auxito-product-fitment__skeleton-line auxito-product-fitment__skeleton-line--short"></div><div class="auxito-product-fitment__skeleton-button"></div></div></article>');
    }
    dom.track.innerHTML = items.join("");
    if (dom.controls) {
      dom.controls.hidden = true;
    }
    hideStatus();
  }
  function normalizeImage(url) {
    return !url ? "" : String(url).indexOf("//") === 0 ? "https:" + url : String(url);
  }
  function buildBlurImage(url) {
    var normalized = normalizeImage(url);
    var parsed;
    if (!normalized) {
      return "";
    }
    try {
      parsed = new URL(normalized, window.location.origin);
      parsed.searchParams.set("width", "24");
      return parsed.toString();
    } catch (error) {
      return normalized;
    }
  }
  function renderImage(url, alt) {
    var image = normalizeImage(url);
    if (!image) {
      return '<div class="search-result-product-placeholder">No image</div>';
    }
    return '<span class="search-result-progressive-image auxito-product-fitment__progressive" data-progressive-image><img class="search-result-progressive-image__blur" src="' + escapeHtml(buildBlurImage(image)) + '" alt="" aria-hidden="true" decoding="async"><img class="search-result-progressive-image__main js-product-fitment-progressive-image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(alt) + '" loading="lazy" decoding="async"></span>';
  }
  function hydrateImages(root) {
    Array.prototype.forEach.call(root.querySelectorAll(".js-product-fitment-progressive-image"), function(image) {
      function markLoaded() {
        if (image.parentElement) {
          image.parentElement.classList.add("is-loaded");
        }
      }
      if (image.dataset.progressiveBound === "true") {
        if (image.complete && image.naturalWidth > 0) {
          markLoaded();
        }
        return;
      }
      image.dataset.progressiveBound = "true";
      if (image.complete && image.naturalWidth > 0) {
        markLoaded();
        return;
      }
      image.addEventListener("load", markLoaded, {
        once: true
      });
      image.addEventListener("error", markLoaded, {
        once: true
      });
    });
  }
  function formatMoney(value) {
    var numeric = Number(value);
    if (!Number.isFinite(numeric)) {
      return "";
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      try {
        return window.Shopify.formatMoney(Math.round(numeric * 100), window.Shopify.money_format);
      } catch (error) {}
    }
    return "$" + numeric.toFixed(2);
  }
  function normalizeSourceUrl(sourceUrl) {
    var raw = str(sourceUrl);
    var parsed;
    var path;
    var match;
    if (!raw) {
      return "";
    }
    try {
      parsed = new URL(raw, window.location.origin);
      path = (parsed.pathname || "").replace(/\/{2,}/g, "/").replace(/\/$/, "");
      match = path.match(/^\/collections\/[^/]+\/products\/([^/?#]+)$/i);
      if (match && match[1]) {
        return "/products/" + match[1];
      }
      if (path.indexOf("/products/") === 0) {
        path = path.replace(/\.js$/i, "");
      }
      return path + (parsed.search || "");
    } catch (error) {
      return raw.replace(/\.js$/i, "");
    }
  }
  function isCollectionSourceUrl(sourceUrl) {
    return normalizeSourceUrl(sourceUrl).indexOf("/collections/") === 0;
  }
  function buildSourceHandleStorageKey(sourceUrl) {
    return FITMENT_SOURCE_HANDLE_STORAGE_KEY_PREFIX + "::" + normalizeSourceUrl(sourceUrl);
  }
  function cloneSourceHandleResult(result) {
    return {
      sourceUrl: str(result && result.sourceUrl),
      handles: Array.isArray(result && result.handles) ? result.handles.slice() : [],
      scanComplete: result && result.scanComplete !== false
    };
  }
  function readCachedSourceHandleResult(sourceUrl) {
    var cacheKey = buildSourceHandleStorageKey(sourceUrl);
    var cached = readJson(window.sessionStorage, cacheKey);
    if (!cached || !cached.savedAt || Date.now() - Number(cached.savedAt || 0) > SOURCE_HANDLE_CACHE_MAX_AGE_MS) {
      return null;
    }
    if (!Array.isArray(cached.handles)) {
      return null;
    }
    return cloneSourceHandleResult({
      sourceUrl: normalizeSourceUrl(sourceUrl),
      handles: dedupe(cached.handles.map(str).filter(Boolean)),
      scanComplete: cached.scanComplete !== false
    });
  }
  function writeCachedSourceHandleResult(sourceUrl, result) {
    var cacheKey = buildSourceHandleStorageKey(sourceUrl);
    var normalized = cloneSourceHandleResult(result);
    if (!normalized.sourceUrl || normalized.scanComplete === false) {
      return normalized;
    }
    writeJson(window.sessionStorage, cacheKey, {
      savedAt: Date.now(),
      scanComplete: true,
      handles: normalized.handles
    });
    return normalized;
  }
  function buildCollectionHandleViewUrl(sourceUrl, pageNumber) {
    var parsed = new URL(normalizeSourceUrl(sourceUrl), window.location.origin);
    if (parsed.pathname.indexOf("/collections/") !== 0) {
      return "";
    }
    parsed.hash = "";
    parsed.searchParams.set("view", COLLECTION_FITMENT_HANDLES_VIEW);
    if (pageNumber > 1) {
      parsed.searchParams.set("page", String(pageNumber));
    } else {
      parsed.searchParams.delete("page");
    }
    return parsed.toString();
  }
  function normalizeCollectionHandlePayload(payload) {
    return {
      handles: dedupe((Array.isArray(payload && payload.handles) ? payload.handles : []).map(str).filter(Boolean)),
      hasNextPage: !!(payload && payload.pagination && (payload.pagination.has_next_page === true || payload.pagination.hasNextPage === true))
    };
  }
  async function inspectSourceHandles(sourceUrl) {
    var key = normalizeSourceUrl(sourceUrl);
    var directHandles = collectHandlesFromSourceUrls([ key ]);
    if (!key) {
      return cloneSourceHandleResult({
        sourceUrl: "",
        handles: [],
        scanComplete: true
      });
    }
    if (directHandles.length || !isCollectionSourceUrl(key)) {
      return cloneSourceHandleResult({
        sourceUrl: key,
        handles: directHandles,
        scanComplete: true
      });
    }
    if (sourceHandleCache.has(key)) {
      return cloneSourceHandleResult(await sourceHandleCache.get(key));
    }
    sourceHandleCache.set(key, async function() {
      var sessionCache = readCachedSourceHandleResult(key);
      var handles = [];
      var seen = new Set;
      var page = 1;
      var hasNext = true;
      if (sessionCache) {
        return sessionCache;
      }
      try {
        while (hasNext && page <= MAX_COLLECTION_VIEW_PAGES) {
          var payload = normalizeCollectionHandlePayload(await fetchJson(buildCollectionHandleViewUrl(key, page)));
          payload.handles.forEach(function(handle) {
            if (!handle || seen.has(handle)) {
              return;
            }
            seen.add(handle);
            handles.push(handle);
          });
          hasNext = payload.hasNextPage;
          page += 1;
        }
      } catch (error) {
        var fallbackProducts = await fetchSourceProducts(key, {
          maxProducts: 0
        });
        return writeCachedSourceHandleResult(key, {
          sourceUrl: key,
          handles: dedupe((fallbackProducts || []).map(function(product) {
            return product && product.handle ? product.handle : "";
          }).filter(Boolean)),
          scanComplete: fallbackProducts && fallbackProducts._scanComplete !== false
        });
      }
      return writeCachedSourceHandleResult(key, {
        sourceUrl: key,
        handles: handles,
        scanComplete: !hasNext
      });
    }().catch(function(error) {
      sourceHandleCache.delete(key);
      throw error;
    }));
    return cloneSourceHandleResult(await sourceHandleCache.get(key));
  }
  async function inspectCandidateSources(candidates) {
    var normalizedSourceUrls = dedupe((Array.isArray(candidates) ? candidates : []).reduce(function(allUrls, candidate) {
      return allUrls.concat(Array.isArray(candidate && candidate.sourceUrls) ? candidate.sourceUrls : []);
    }, []).map(normalizeSourceUrl).filter(Boolean));
    var inspections = await mapWithConcurrencyLimit(normalizedSourceUrls, MAX_SOURCE_CONCURRENCY, async function(sourceUrl) {
      try {
        return await inspectSourceHandles(sourceUrl);
      } catch (error) {
        console.warn("Failed to inspect fitment source for current PDP:", sourceUrl, error);
        return {
          sourceUrl: sourceUrl,
          handles: [],
          scanComplete: false,
          failed: true
        };
      }
    });
    return inspections.reduce(function(map, result) {
      map.set(str(result && result.sourceUrl), result || null);
      return map;
    }, new Map);
  }
  function wait(ms) {
    return new Promise(function(resolve) {
      window.setTimeout(resolve, ms);
    });
  }
  async function fetchJson(url) {
    var response = await fetchWithRetry(url, {
      credentials: "same-origin"
    });
    return response.json();
  }
  async function fetchText(url) {
    var response = await fetchWithRetry(url, {
      credentials: "same-origin"
    });
    return response.text();
  }
  function handleProductFitmentQuickshopSubmit(controller, event) {
    var formArray;
    var idEntry;
    if (event) {
      event.preventDefault();
    }
    if (!quickshopRuntime || !controller || !controller.$form || !controller.$form.length || !controller.$productAtcButton || !controller.$productAtcButton.length) {
      return;
    }
    formArray = controller.$form.serializeArray();
    idEntry = formArray.find(function(entry) {
      return entry.name === "id";
    });
    if (!idEntry || !idEntry.value) {
      return;
    }
    controller.$productAtcButton.prop("disabled", true).addClass("processing").attr("aria-busy", "true");
    controller.toggleMessage("", false);
    quickshopRuntime.postCartAddRequest(formArray).then(async function() {
      var cartService;
      var drawerController;
      var headerButton;
      closeQuickshopModal();
      await wait(120);
      cartService = window.Auxito && window.Auxito.CartService;
      if (cartService && typeof cartService.fetchCart === "function" && typeof cartService.openCart === "function") {
        var serviceCart = await cartService.fetchCart(true);
        await cartService.openCart(serviceCart, controller.trigger || controller.$productAtcButton[0]);
        return;
      }
      drawerController = window.Auxito && window.Auxito.CartDrawer ? window.Auxito.CartDrawer.controller : window.AuxitoCartDrawerController;
      if (drawerController && typeof drawerController.fetchCart === "function" && typeof drawerController.openWithCart === "function") {
        var cart = await drawerController.fetchCart(true);
        await drawerController.openWithCart(cart, controller.trigger || controller.$productAtcButton[0]);
        return;
      }
      headerButton = document.querySelector(".site-header-cart--button.js-site-header-cart--button");
      if (headerButton && typeof headerButton.click === "function") {
        headerButton.click();
      }
    }).catch(function(error) {
      console.warn("Product-fitment quickshop ATC failed:", error);
      controller.$productAtcButton.prop("disabled", false).removeClass("processing").removeAttr("aria-busy");
      controller.toggleMessage('<div class="product-message--error">' + escapeHtml(String(error && error.message || "Unable to add this item to cart.")) + "</div>", true);
    });
  }
  function closeQuickshopModal() {
    if (state.activeQuickshop && typeof state.activeQuickshop.close === "function") {
      state.activeQuickshop.close();
    } else if (quickshopRuntime) {
      quickshopRuntime.resetModal();
    }
    state.activeQuickshop = null;
  }
  async function openQuickshopForButton(button) {
    var handle = str(button && button.getAttribute("data-fitment-handle"));
    var productUrl = str(button && button.getAttribute("data-product-url"));
    var payload;
    var quickshop;
    if (!handle || !button || button.disabled) {
      return;
    }
    if (!quickshopRuntime) {
      navigateTo(productUrl);
      return;
    }
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    button.setAttribute("data-state", "loading");
    setButtonText(button, "Loading...");
    hideStatus();
    try {
      payload = await quickshopRuntime.fetchQuickshopPayload(handle);
      if (!payload) {
        throw new Error("Quickshop payload unavailable for " + handle);
      }
      closeQuickshopModal();
      quickshop = quickshopRuntime.createQuickshop(payload, button, {
        modalClass: "quickshop-slim",
        submitNamespace: "product-fitment-quickshop",
        variantNamespace: "product-fitment-variant-helper",
        galleryNamespace: "product-fitment-quickshop-gallery",
        logPrefix: "product-fitment quickshop",
        currentModalId: function(activePayload) {
          return "product-fitment-quickshop-" + String(activePayload && activePayload.handle ? activePayload.handle : "default");
        },
        submitHandler: handleProductFitmentQuickshopSubmit
      });
      if (!quickshop.open()) {
        throw new Error("Quickshop modal unavailable for " + handle);
      }
      state.activeQuickshop = quickshop;
    } catch (error) {
      console.warn("Failed to open product-fitment quickshop:", handle, error);
      navigateTo(productUrl);
    } finally {
      button.disabled = false;
      button.removeAttribute("aria-busy");
      button.removeAttribute("data-state");
      setButtonText(button, button.getAttribute("data-default-label") || "Choose Options");
    }
  }
  function centsToMoney(value) {
    var numeric = Number(value);
    return Number.isFinite(numeric) ? numeric / 100 : null;
  }
  function normalizeProduct(raw, sourceUrl) {
    var variants = Array.isArray(raw && raw.variants) ? raw.variants : [];
    var defaultOnly = raw && (raw.has_only_default_variant === true || raw.hasOnlyDefaultVariant === true || raw.has_only_default_variant === "true" || variants.length === 1 && (!variants[0].title || variants[0].title === "Default Title"));
    var primary = defaultOnly ? variants.find(function(variant) {
      return variant && variant.available !== false;
    }) || variants[0] || null : null;
    var featured = raw && typeof raw.featured_image === "string" ? raw.featured_image : raw && raw.featured_image && raw.featured_image.src ? raw.featured_image.src : Array.isArray(raw && raw.images) && raw.images[0] ? typeof raw.images[0] === "string" ? raw.images[0] : raw.images[0].src : "";
    if (!raw || !raw.handle) {
      return null;
    }
    return {
      handle: str(raw.handle),
      url: "/products/" + str(raw.handle),
      title: str(raw.title),
      image: normalizeImage(featured),
      imageAlt: str(raw.title),
      available: defaultOnly ? !!(primary ? primary.available !== false : raw.available !== false) : raw.available !== false,
      requiresOptions: !defaultOnly,
      variantId: primary && primary.id ? String(primary.id) : "",
      price: primary && primary.price != null ? centsToMoney(primary.price) : centsToMoney(raw.price),
      compareAtPrice: primary && primary.compare_at_price != null ? centsToMoney(primary.compare_at_price) : centsToMoney(raw.compare_at_price),
      sourceUrls: dedupe([ sourceUrl ])
    };
  }
  function normalizeSourceFetchOptions(options) {
    var hasCustomMax = !!(options && Object.prototype.hasOwnProperty.call(options, "maxProducts"));
    var maxProducts = hasCustomMax ? Number(options.maxProducts) : MAX_COLLECTION_PRODUCTS_TO_SCAN;
    return {
      maxProducts: Number.isFinite(maxProducts) && maxProducts > 0 ? maxProducts : 0,
      targetHandle: str(options && options.targetHandle)
    };
  }
  function createSourceProductList(items, scanComplete) {
    var list = Array.isArray(items) ? items : [];
    list._scanComplete = scanComplete !== false;
    return list;
  }
  async function fetchSourceProducts(sourceUrl, options) {
    var key = normalizeSourceUrl(sourceUrl);
    var requestOptions = normalizeSourceFetchOptions(options);
    var cacheKey = key ? [ key, String(requestOptions.maxProducts || 0), requestOptions.targetHandle ].join("::") : "";
    if (!cacheKey) {
      return createSourceProductList([], true);
    }
    if (sourceCache.has(cacheKey)) {
      return sourceCache.get(cacheKey);
    }
    sourceCache.set(cacheKey, async function() {
      var parsed = new URL(key, window.location.origin);
      var products = [];
      var seen = new Set;
      var page = 1;
      var hasNext = true;
      var targetMatched = false;
      if (parsed.pathname.indexOf("/products/") === 0) {
        var productData = await fetchJson(new URL(parsed.pathname.replace(/\.js$/i, "") + ".js", window.location.origin).toString());
        return createSourceProductList([ normalizeProduct(productData, key) ].filter(Boolean), true);
      }
      if (parsed.pathname.indexOf("/collections/") !== 0) {
        return createSourceProductList([], true);
      }
      while (hasNext && page <= MAX_COLLECTION_VIEW_PAGES && (!requestOptions.maxProducts || products.length < requestOptions.maxProducts)) {
        var viewUrl = new URL(key, window.location.origin);
        var payload;
        var rawProducts;
        var previousCount = products.length;
        viewUrl.searchParams.set("view", "search-result-data");
        if (page > 1) {
          viewUrl.searchParams.set("page", String(page));
        } else {
          viewUrl.searchParams.delete("page");
        }
        payload = await fetchJson(viewUrl.toString());
        rawProducts = Array.isArray(payload && payload.products) ? payload.products : [];
        rawProducts.map(function(raw) {
          return normalizeProduct(raw, key);
        }).filter(Boolean).forEach(function(product) {
          if (!product.handle || seen.has(product.handle) || requestOptions.maxProducts && products.length >= requestOptions.maxProducts) {
            return;
          }
          seen.add(product.handle);
          products.push(product);
          if (requestOptions.targetHandle && product.handle === requestOptions.targetHandle) {
            targetMatched = true;
          }
        });
        hasNext = !!(payload && payload.pagination && (payload.pagination.has_next_page === true || payload.pagination.hasNextPage === true));
        if (products.length === previousCount) {
          hasNext = false;
        }
        if (targetMatched) {
          hasNext = false;
        }
        page += 1;
      }
      return createSourceProductList(products, !hasNext || targetMatched);
    }().catch(function(error) {
      sourceCache.delete(cacheKey);
      throw error;
    }));
    return sourceCache.get(cacheKey);
  }
  async function fetchCompactProduct(handle, compactArtifactsConfig) {
    var normalizedHandle = str(handle);
    var cacheKey = [ str(compactArtifactsConfig && compactArtifactsConfig.compactArtifactVersion), normalizedHandle ].join("::");
    if (!cacheKey) {
      return null;
    }
    if (compactProductCache.has(cacheKey)) {
      return compactProductCache.get(cacheKey);
    }
    compactProductCache.set(cacheKey, async function() {
      var sourceUrls = await getCompactSourceUrlsForHandle(normalizedHandle, compactArtifactsConfig);
      var sourceUrl = sourceUrls[0] || "/products/" + normalizedHandle;
      var productData = await fetchJson(new URL("/products/" + encodeURIComponent(normalizedHandle) + ".js", window.location.origin).toString());
      return normalizeProduct(productData, sourceUrl);
    }().catch(function(error) {
      compactProductCache.delete(cacheKey);
      throw error;
    }));
    return compactProductCache.get(cacheKey);
  }
  async function loadRecommendations(context) {
    var sourceUrls = dedupe((context.payload && context.payload.sourceUrls || []).map(normalizeSourceUrl).filter(Boolean));
    var rankedHandles = context.payload && Array.isArray(context.payload.handles) ? context.payload.handles : [];
    var merged = new Map;
    var failedCount = 0;
    async function loadOne(sourceUrl, sourceIndex) {
      try {
        var products = await fetchSourceProducts(sourceUrl);
        products.forEach(function(product, productIndex) {
          var existing;
          if (!product || !product.handle || product.handle === state.product.handle) {
            return;
          }
          existing = merged.get(product.handle);
          if (!existing) {
            existing = Object.assign({}, product, {
              _sourceIndex: sourceIndex,
              _productIndex: productIndex
            });
            merged.set(product.handle, existing);
            return;
          }
          existing.sourceUrls = dedupe((existing.sourceUrls || []).concat(product.sourceUrls || []));
          existing._sourceIndex = Math.min(existing._sourceIndex, sourceIndex);
          existing._productIndex = Math.min(existing._productIndex, productIndex);
        });
      } catch (error) {
        failedCount += 1;
        console.warn("Failed to load product-fitment source:", sourceUrl, error);
      }
    }
    if (!sourceUrls.length) {
      return {
        failedCount: 0,
        products: []
      };
    }
    await mapWithConcurrencyLimit(sourceUrls, MAX_SOURCE_CONCURRENCY, loadOne);
    return {
      failedCount: failedCount,
      products: Array.from(merged.values()).sort(function(left, right) {
        var leftRank = rankedHandles.indexOf(left.handle);
        var rightRank = rankedHandles.indexOf(right.handle);
        leftRank = leftRank === -1 ? Number.MAX_SAFE_INTEGER : leftRank;
        rightRank = rightRank === -1 ? Number.MAX_SAFE_INTEGER : rightRank;
        if (leftRank !== rightRank) {
          return leftRank - rightRank;
        }
        if (left._sourceIndex !== right._sourceIndex) {
          return left._sourceIndex - right._sourceIndex;
        }
        if (left._productIndex !== right._productIndex) {
          return left._productIndex - right._productIndex;
        }
        return str(left.title).localeCompare(str(right.title));
      }).slice(0, MAX_PRODUCTS_TOTAL).map(function(product) {
        delete product._sourceIndex;
        delete product._productIndex;
        return product;
      })
    };
  }
  // Dynamic categories (LED Bulbs / Accessories & Kits / Lighting Assemblies):
  // fetch the first DYNAMIC_PER_LOCATION_LIMIT products from each location group.
  async function loadDynamicRecommendations(context) {
    var locationGroups = context.payload.locationGroups;
    var results = [];
    var failedCount = 0;
    async function loadOneGroup(group) {
      var groupProducts = [];
      var i, j, products, product;
      try {
        for (i = 0; i < group.sourceUrls.length && groupProducts.length < DYNAMIC_PER_LOCATION_LIMIT; i++) {
          products = await fetchSourceProducts(group.sourceUrls[i]);
          for (j = 0; j < products.length && groupProducts.length < DYNAMIC_PER_LOCATION_LIMIT; j++) {
            product = products[j];
            if (!product || !product.handle || product.handle === state.product.handle) {
              continue;
            }
            if (groupProducts.some(function(p) { return p.handle === product.handle; })) {
              continue;
            }
            groupProducts.push(Object.assign({}, product, { _locationLabel: group.locationLabel }));
          }
        }
        results = results.concat(groupProducts);
      } catch (error) {
        failedCount += 1;
        console.warn("Failed to load recommendations for location:", group.locationKey, error);
      }
    }
    await mapWithConcurrencyLimit(locationGroups, MAX_SOURCE_CONCURRENCY, loadOneGroup);
    return { failedCount: failedCount, products: results };
  }
  async function loadCompactDynamicRecommendations(context) {
    var compactArtifactsConfig = resolveCompactFitmentArtifactsConfig(readArtifactsConfig("search-result-artifacts-config"));
    var locationGroups = context && context.payload && Array.isArray(context.payload.locationGroups) ? context.payload.locationGroups : [];
    var selectedEntries = [];
    var seenHandles = new Set([ state.product.handle ]);
    var failedCount = 0;
    if (!compactArtifactsConfig || !locationGroups.length) {
      return loadDynamicRecommendations(context);
    }
    await mapWithConcurrencyLimit(locationGroups, MAX_SOURCE_CONCURRENCY, async function(group) {
      var handles = dedupe((await Promise.all((group.sourceUrls || []).map(function(sourceUrl) {
        return getCompactHandlesForSourceUrl(sourceUrl, compactArtifactsConfig);
      }))).reduce(function(allHandles, groupHandles) {
        return allHandles.concat(Array.isArray(groupHandles) ? groupHandles : []);
      }, []));
      var selectedHandle = handles.find(function(handle) {
        return handle && !seenHandles.has(handle);
      });
      if (!selectedHandle) {
        return;
      }
      seenHandles.add(selectedHandle);
      selectedEntries.push({
        handle: selectedHandle,
        locationLabel: str(group && group.locationLabel)
      });
    });
    var products = await mapWithConcurrencyLimit(selectedEntries.slice(0, MAX_PRODUCTS_TOTAL), MAX_SOURCE_CONCURRENCY, async function(entry) {
      try {
        var product = await fetchCompactProduct(entry.handle, compactArtifactsConfig);
        if (!product || !product.handle || product.handle === state.product.handle) {
          return null;
        }
        product._locationLabel = entry.locationLabel;
        return product;
      } catch (error) {
        failedCount += 1;
        console.warn("Failed to load compact product-fitment recommendation:", entry.handle, error);
        return null;
      }
    });
    return {
      failedCount: failedCount,
      products: products.filter(Boolean)
    };
  }
  function resolveApplicationLabel(payload) {
    return str(payload && payload.locationLabel) || str(payload && payload.queryCategory) || APP_LABEL_MAP[lower(payload && payload.categorySlug)] || "";
  }
  function resolveCardAction(product) {
    if (!product.available) {
      return {
        type: "sold_out",
        label: "Sold Out",
        disabled: true
      };
    }
    if (product.requiresOptions || !str(product.variantId)) {
      return {
        type: "choose_options",
        label: "Choose Options",
        disabled: false
      };
    }
    return {
      type: "add_to_cart",
      label: "Add to Cart",
      disabled: false
    };
  }
  function renderRecommendations(result, context) {
    var fallbackLabel = resolveApplicationLabel(context.payload);
    var usePerCardLabel = !!(context.payload && Array.isArray(context.payload.locationGroups) && context.payload.locationGroups.length);
    state.recommendations = result.products.slice();
    dom.section.hidden = false;
    dom.section.classList.add("auxito-product-fitment--bootstrap");
    dom.section.classList.remove("auxito-product-fitment--loading");
    if (dom.title) {
      dom.title.textContent = context.vehicleDisplay ? "Recommended for Your " + context.vehicleDisplay : "Recommended for Your Vehicle";
    }
    dom.track.innerHTML = result.products.map(function(product, index) {
      var action = resolveCardAction(product);
      var cardUrl = appendIncomingLampContext(product.url);
      var cardLabel = usePerCardLabel ? (str(product._locationLabel) || fallbackLabel) : fallbackLabel;
      var compare = product.compareAtPrice != null && product.compareAtPrice > product.price ? '<span class="auxito-product-fitment__compare">' + escapeHtml(formatMoney(product.compareAtPrice)) + "</span>" : '<span class="auxito-product-fitment__compare"></span>';
      var buttonAttrs = 'class="auxito-product-fitment__button" type="button" data-fitment-action="' + escapeHtml(action.type) + '" data-product-url="' + escapeHtml(cardUrl) + '" data-fitment-handle="' + escapeHtml(product.handle) + '" data-default-label="' + escapeHtml(action.label) + '"' + (product.variantId ? ' data-variant-id="' + escapeHtml(product.variantId) + '"' : "") + (action.disabled ? " disabled" : "");
      return '<article class="auxito-product-fitment__card" data-fitment-product-card data-fitment-handle="' + escapeHtml(product.handle) + '" data-product-url="' + escapeHtml(cardUrl) + '" data-fitment-real-index="' + String(index + 1) + '" role="link" tabindex="0" aria-label="View ' + escapeHtml(product.title) + '"><a class="auxito-product-fitment__media-link" href="' + escapeHtml(cardUrl) + '">' + renderImage(product.image, product.imageAlt || product.title) + '</a><div class="auxito-product-fitment__body"><a class="auxito-product-fitment__name-link" href="' + escapeHtml(cardUrl) + '"><h3 class="auxito-product-fitment__name">' + escapeHtml(product.title) + "</h3></a>" + (cardLabel ? '<div class="auxito-product-fitment__application">' + escapeHtml(cardLabel) + "</div>" : "") + '<div class="auxito-product-fitment__pricing"><span class="auxito-product-fitment__price">' + escapeHtml(formatMoney(product.price)) + "</span>" + compare + "</div><button " + buttonAttrs + "><span>" + escapeHtml(action.label) + "</span></button></div></article>";
    }).join("");
    Array.prototype.slice.call(dom.track.childNodes).forEach(function(node) {
      if (node.nodeType !== 1) {
        dom.track.removeChild(node);
      }
    });
    hydrateImages(dom.track);
    syncCarousel();
    hideStatus();
    if (result.failedCount) {
      showStatus("Some recommendations could not be refreshed just now.", "info");
    }
  }
  function navigateTo(url) {
    if (!str(url)) {
      return;
    }
    window.location.href = url;
  }
  function setButtonText(button, text) {
    var span = button && button.querySelector ? button.querySelector("span") : null;
    if (span) {
      span.textContent = str(text);
      return;
    }
    if (button) {
      button.textContent = str(text);
    }
  }
  async function handleAddToCart(button) {
    var variantId = str(button && button.getAttribute("data-variant-id"));
    var cartService = window.Auxito && window.Auxito.CartService;
    if (!variantId || button.disabled) {
      return;
    }
    if (state.buttonResetTimer) {
      window.clearTimeout(state.buttonResetTimer);
      state.buttonResetTimer = 0;
    }
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    button.setAttribute("data-state", "loading");
    setButtonText(button, "Adding...");
    hideStatus();
    try {
      if (cartService && typeof cartService.addAndOpen === "function") {
        await cartService.addAndOpen([
          { name: "id", value: variantId },
          { name: "quantity", value: "1" }
        ], button);
      } else {
        var controller = window.Auxito && window.Auxito.CartDrawer ? window.Auxito.CartDrawer.controller : window.AuxitoCartDrawerController;
        await fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
          },
          body: "id=" + encodeURIComponent(variantId) + "&quantity=1"
        }).then(async function(response) {
          var errorData;
          if (response.ok) {
            return response.json();
          }
          try {
            errorData = await response.json();
          } catch (error) {}
          throw new Error(errorData && (errorData.description || errorData.message) ? errorData.description || errorData.message : "Cart add failed: " + response.status);
        });
        if (controller && typeof controller.fetchCart === "function" && typeof controller.openWithCart === "function") {
          var cart = await controller.fetchCart(true);
          await controller.openWithCart(cart, button);
        } else {
          var headerButton = document.querySelector(".site-header-cart--button.js-site-header-cart--button");
          if (headerButton && typeof headerButton.click === "function") {
            headerButton.click();
          }
        }
      }
      button.setAttribute("data-state", "success");
      setButtonText(button, "Added");
      state.buttonResetTimer = window.setTimeout(function() {
        button.disabled = false;
        button.removeAttribute("aria-busy");
        button.removeAttribute("data-state");
        setButtonText(button, button.getAttribute("data-default-label") || "Add to Cart");
      }, 1400);
    } catch (error) {
      button.disabled = false;
      button.removeAttribute("aria-busy");
      button.removeAttribute("data-state");
      setButtonText(button, button.getAttribute("data-default-label") || "Add to Cart");
      showStatus(error && error.message ? error.message : "Unable to add this item to cart.", "error");
    }
  }
  function isMobileViewport() {
    return typeof window.matchMedia=== "function" ? window.matchMedia("(max-width: " + String(MOBILE_VIEWPORT_MAX_WIDTH) + "px)").matches : window.innerWidth <= MOBILE_VIEWPORT_MAX_WIDTH;
  }
  function syncCarousel() {
    if (state.carouselFrame) {
      return;
    }
    state.carouselFrame = window.requestAnimationFrame(function() {
      var overflow = dom.viewport.scrollWidth > dom.viewport.clientWidth + 2;
      var maxScroll = Math.max(0, dom.viewport.scrollWidth - dom.viewport.clientWidth - 2);
      state.carouselFrame = 0;
      if (!dom.controls || !dom.prevButton || !dom.nextButton) {
        return;
      }
      if (!state.recommendations.length || !overflow || isMobileViewport()) {
        dom.controls.hidden = true;
        dom.prevButton.disabled = true;
        dom.nextButton.disabled = true;
        return;
      }
      dom.controls.hidden = false;
      dom.prevButton.disabled = dom.viewport.scrollLeft <= 2;
      dom.nextButton.disabled = dom.viewport.scrollLeft >= maxScroll;
    });
  }
  function getPageStep() {
    var cards = dom.track.querySelectorAll(".auxito-product-fitment__card");
    if (!cards.length) {
      return dom.viewport.clientWidth;
    }
    if (cards.length > 1) {
      var step = cards[1].offsetLeft - cards[0].offsetLeft;
      if (step > 0) {
        return step * Math.max(1, Math.floor((dom.viewport.clientWidth + 1) / step));
      }
    }
    return dom.viewport.clientWidth;
  }
  async function refreshFitment() {
    var token;
    var context = createContextSnapshot();
    var key;
    var result;
    clearPendingFitmentUiTimer();
    token = state.activeLoadToken + 1;
    state.activeLoadToken = token;
    state.context = context;
    if (context.validationPending) {
      state.pendingSince = Date.now();
    }
    renderFitsBanner(context);
    if (context.validationPending) {
      state.contextKey = "";
      hideSection();
      schedulePendingFitmentUi(context, token);
      // 等待超时后重新套一次购买锁（Checking 放开）；新一轮校验清掉上一轮的计时
      window.clearTimeout(state.pendingLockTimer);
      state.pendingLockTimer = window.setTimeout(function() {
        if (token === state.activeLoadToken && state.context && state.context.validationPending) {
          applyPurchaseLock(state.context);
        }
      }, PENDING_LOCK_MS + 100);
    }
    try {
      context = await resolveContext(context);
    } catch (error) {
      // 判断过程出错：结束等待状态（按判断不了处理，与读取失败一致不锁购买、不留下永久的锁）
      console.warn("Failed to resolve PDP fitment context:", error);
      context = Object.assign({}, context, { validationPending: false });
    }
    if (token !== state.activeLoadToken) {
      return;
    }
    clearPendingFitmentUiTimer();
    key = buildContextKey(context);
    state.context = context;
    renderFitsBanner(context);
    if (!context.valid) {
      state.contextKey = key;
      hideSection();
      return;
    }
    if (state.contextKey === key && state.recommendations.length) {
      syncCarousel();
      return;
    }
    state.contextKey = key;
    showLoading(context);
    try {
      // Dynamic categories (LED Bulbs / Accessories & Kits / Lighting Assemblies):
      // use per-location loading (2 products per location). Static: flat merge.
      if (context.payload.locationGroups && context.payload.locationGroups.length && context.payload.recordKind === "compact") {
        result = await loadCompactDynamicRecommendations(context);
      } else if (context.payload.locationGroups && context.payload.locationGroups.length && context.payload.recordKind === "dynamic") {
        result = await loadDynamicRecommendations(context);
      } else {
        result = await loadRecommendations(context);
      }
      if (token !== state.activeLoadToken) {
        return;
      }
      if (!result.products.length) {
        hideSection();
        return;
      }
      renderRecommendations(result, context);
    } catch (error) {
      if (token !== state.activeLoadToken) {
        return;
      }
      console.warn("Failed to load product-fitment recommendations:", error);
      hideSection();
    }
  }
  function bindEvents() {
    document.addEventListener("click", function(event) {
      var vehicleTrigger = event.target.closest("[data-fitment-open-vehicle-modal]");
      var configOption = event.target.closest("[data-fitment-config-value]");
      var configReset = event.target.closest("[data-fitment-config-reset]");
      var patch = {};
      if (vehicleTrigger) {
        event.preventDefault();
        openVehicleSelector();
      }
      if (configOption) {
        event.preventDefault();
        patch[configOption.closest("[data-fitment-config-dimension]").getAttribute("data-fitment-config-dimension")] = configOption.getAttribute("data-fitment-config-value");
        saveVisitorConfig(patch);
      }
      if (configReset) {
        event.preventDefault();
        patch[configReset.getAttribute("data-fitment-config-reset")] = "";
        saveVisitorConfig(patch);
      }
    });
    dom.track.addEventListener("click", function(event) {
      var button = event.target.closest("[data-fitment-action]");
      var link = event.target.closest(".auxito-product-fitment__media-link, .auxito-product-fitment__name-link");
      var card = event.target.closest("[data-fitment-product-card]");
      if (button) {
        event.preventDefault();
        event.stopPropagation();
        if (button.getAttribute("data-fitment-action") === "add_to_cart") {
          handleAddToCart(button);
        } else if (button.getAttribute("data-fitment-action") === "choose_options") {
          openQuickshopForButton(button);
        }
        return;
      }
      if (link) {
        return;
      }
      if (card) {
        event.preventDefault();
        navigateTo(card.getAttribute("data-product-url"));
      }
    });
    dom.track.addEventListener("keydown", function(event) {
      var card = event.target.closest("[data-fitment-product-card]");
      if (!card || event.target !== card) {
        return;
      }
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        navigateTo(card.getAttribute("data-product-url"));
      }
    });
    document.addEventListener("click", function(event) {
      var parts = state.activeQuickshop && quickshopRuntime ? quickshopRuntime.getNativeModalParts() : null;
      if (state.activeQuickshop && event.target.closest("[data-modal-close]")) {
        event.preventDefault();
        closeQuickshopModal();
        return;
      }
      if (state.activeQuickshop && parts && event.target === parts.container) {
        event.preventDefault();
        closeQuickshopModal();
      }
    });
    window.addEventListener("keydown", function(event) {
      if (event.key === "Escape" && state.activeQuickshop) {
        closeQuickshopModal();
      }
    });
    if (dom.prevButton) {
      dom.prevButton.addEventListener("click", function() {
        dom.viewport.scrollBy({
          left: -getPageStep(),
          behavior: "smooth"
        });
      });
    }
    if (dom.nextButton) {
      dom.nextButton.addEventListener("click", function() {
        dom.viewport.scrollBy({
          left: getPageStep(),
          behavior: "smooth"
        });
      });
    }
    dom.viewport.addEventListener("scroll", syncCarousel, {
      passive: true
    });
    window.addEventListener("resize", syncCarousel, {
      passive: true
    });
    window.addEventListener("auxito:vehicle-context-changed", refreshFitment);
  }
})(window, document);